export default {
  domainDirectory: {
    title: "Tên miền chính thức", subtitle: "Kiểm tra địa chỉ chính thức tại đây. Chạm để sao chép.", available: " địa chỉ có thể kết nối",
    loading: "Đang tải tên miền…", loadFailed: "Không thể tải tên miền", retry: "Tải lại", empty: "Chưa có tên miền hoạt động",
    tapToCopy: "Chạm để sao chép", checking: "Đang kiểm tra", checkingShort: "Đang kiểm tra", online: "Có thể kết nối", offline: "Kết nối quá thời gian",
    waiting: "Đang chờ kiểm tra", timeout: "Quá thời gian", testAll: "Kiểm tra tất cả tên miền", updatedEveryFifteenSeconds: "Kết nối được tự động kiểm tra mỗi 15 giây",
    saveReminder: "Hãy chụp màn hình trang này để lưu thông tin tên miền", copied: "Đã sao chép tên miền",
    names: { primary: "Tên miền chính", chinaAccel: "Tăng tốc Trung Quốc", secondary: "Tên miền phụ" },
  },
  nickname: {"edit": "Sửa biệt danh", "hint": "2–20 chữ Trung/Anh, số hoặc _", "saved": "Đã lưu biệt danh", "taken": "Biệt danh này đã được sử dụng", "invalid": "Dùng 2–20 chữ Trung/Anh, số hoặc _. Không dùng tên dành riêng.", "failed": "Không thể lưu. Vui lòng thử lại."},
  common: {
    confirm: "Xác nhận",
    cancel: "Hủy bỏ",
    search: "Tìm kiếm",
    language: "Ngôn ngữ",
    switched: "Đã chuyển",
    currentLanguage: "Ngôn ngữ hiện tại",
    selectLanguage: "Chọn ngôn ngữ",
    loading: "Đang tải...",
    loadingMore: "Đang tải thêm...",
    noMoreData: "Không còn dữ liệu",
    noData: "Không có dữ liệu",
    serverUnavailable: "Máy chủ tạm thời không khả dụng",
    loadFailed: "Tải thất bại",
    requestFailed: "Yêu cầu thất bại",
    projectName: "PANTA MARKET",
    duplicateSubmission: "Vui lòng không gửi lại",
    fee: "Phí",
    tip: "Thông báo",
    connecting: "Đang kết nối...",
    connectWalletFirst: "Vui lòng kết nối ví trước",
    connect: "Kết nối",
    insufficientBalance: "Số dư không đủ",
    developing: "Tính năng đang phát triển",
    copyFailed: "Sao chép thất bại",
    sessionAuthRelogin: "Đăng nhập lại",
    sessionAuthStay: "Ở lại",
    pleaseRelogin: "Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại",
    retry: "Nhấn để thử lại",
    submit: "Gửi",
    pager: {
      prevPage: "Trước",
      nextPage: "Sau",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Đến trang",
      jumpConfirm: "Đi",
    },
  },
  tabbar: {
    home: "Trang chủ",
    market: "Dòng thời gian",
    timeline: "Dòng thời gian",
    prediction: "Dự đoán hợp đồng sự kiện AI",
    createMarket: "Tạo thị trường",
    planet: "Hành tinh",
    trade: "Giao dịch",
    finance: "Tài chính",
    fund: "Quỹ",
    assets: "Tài sản",
    planethistory: "Lịch sử"
  },
  tradeMenu: {
    contract: "Hợp đồng sự kiện",
    insurance: "Bảo hiểm",
    spot: "Giao ngay",
    flash: "Hoán đổi nhanh"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI dự đoán · Hợp đồng sự kiện · Phân tích thông minh",
    predictionCategories: {
      hot: "Dòng thời gian",
      sports: "Thể thao",
      world: "Thế giới",
      politics: "Chính trị",
      economy: "Kinh tế"
    },
    predictionSubCategories: {
      crypto: "Giao ngay",
      forex: "Forex",
      commodities: "Hàng hóa"
    },
    features: {
      recharge: "Nạp tiền",
      rechargeDesc: "Nạp tiền nhanh chóng",
      contract: "Hợp đồng sự kiện",
      contractDesc: "Công cụ tài chính sáng tạo",
      predict: "Dự đoán AI",
      fund: "PANTA MARKET Treasury",
      invite: "Mời bạn bè",
      global: "Nút toàn cầu"
    },
    insurance: {
      title: "Quỹ bảo hiểm hợp đồng (TAKER)",
      aiPoolTitle: "Quỹ bảo hiểm AI",
      ordinaryPoolTitle: "Quỹ giá trị bảo hiểm thường",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (tham khảo)",
      more: "Tìm hiểu thêm",
      yesterday: "Thêm hôm qua",
      service: "Dịch vụ thông minh"
    },
    market: {
      tabs: {
        main: "Chính",
        hot: "Phổ biến",
        rise: "Tăng",
        price: "Bảng giá"
      },
      headers: {
        pair: "Cặp",
        latest: "Giá mới nhất",
        change: "Thay đổi 24h"
      },
      viewMore: "Xem thêm",
      collapse: "Thu gọn"
    },
    announcement: {
      title: "Thông báo",
      heading: "Thông báo",
      text: "Chào mừng bạn đến với PANTA MARKET. Tại đây, bạn sẽ được trải nghiệm hệ thống AI và bảo hiểm dự đoán độc đáo do PANTA MARKET tạo ra, cho phép bạn dễ dàng tham gia thị trường dự đoán WEB3 và bắt đầu hành trình làm giàu của mình.",
      time: "2025/11/19 10:00",
      gotIt: "Đã hiểu",
      viewDetail: "Xem chi tiết",
      systemLabel: "Thông báo hệ thống"
    },
    timePeriods: {
      "1min": "1 Phút",
      "30min": "30 Phút",
      "1hour": "1 Giờ"
    },
    footer: {
      australia: "· Úc",
      uae: "· Các Tiểu vương quốc Ả Rập Thống nhất",
      attention: "· CHÚ Ý:",
      attentionText: "PANTA MARKET là một công ty thị trường dự đoán WEB3 dựa trên AI tự vận hành. Chúng tôi không ủy quyền cho bất kỳ bên thứ ba nào thu phí dưới bất kỳ hình thức hoặc tên nào. Mọi thắc mắc, vui lòng liên hệ với dịch vụ khách hàng chính thức tại: {email}"
    },
    timeframes: {
      "1s": "1 phút",
      "1m": "1 phút",
      "5m": "5 phút",
      "15m": "15 phút",
      "1h": "1 giờ",
      "4h": "4 giờ",
      "1d": "1 ngày"
    },
    statusHotEn: "HOT",
    yes: "Có",
    no: "Không",
    hotBannerTitle: "Hợp đồng sự kiện",
    homeBanner: {
      s1t1: "Được hỗ trợ bởi AI",
      s1t2: "Hệ sinh thái lõi AstralX",
      s1cta: "AstralX",
      s2t: "Quỹ Galaxy",
      s2s1: "Tìm hiểu bảo vệ gốc",
      s2s2: "và quy tắc trả thưởng",
      s2cta: "Đăng ký",
      s3s: "Dự đoán giá",
      s3cta: "Dự đoán",
    },
    catCrypto: "Tiền mã hóa",
    catMetal: "Kim loại",
    catSports: "Thể thao",
    catPolitics: "Chính trị",
    catEntertainment: "Giải trí",
    statusHot: "Nóng",
    statusLocked: "Khóa",
    statusLive: "Đang diễn ra",
    statusLockedWait: "Khóa, chờ tất toán",
    jouleUnit: "JOULE",
    nowLabel: "Hiện tại",
    endAtFallback: "--",
    predictionLabel: "Dự đoán",
    rise: "Up",
    fall: "Giảm",
    viewMoreOptions: "Xem thêm {n} tùy chọn",
    categoryAll: "Tất cả",
    categoryCrypto: "Tiền mã hóa",
    categoryEquity: "Cổ phiếu",
    categoryCommodity: "Hàng hóa",
    categoryForex: "Ngoại hối",
    categoryMetal: "Kim loại"
  },
  withdraw: {
    title: "Rút tiền",
    headerTitle: "Rút tiền",
    address: "Địa chỉ rút tiền",
    addressLabel: "Địa chỉ rút tiền",
    addressPlaceholder: "Nhập hoặc dán địa chỉ",
    network: "Mạng",
    selectNetwork: "Chọn mạng",
    networkHint: "Vui lòng đảm bảo địa chỉ rút tiền khớp với mạng đã chọn",
    withdrawAmount: "Số tiền rút",
    receiveAmount: "Số tiền nhận",
    networkFee: "Phí mạng",
    submit: "Xác nhận rút tiền",
    submitButton: "Rút tiền",
    balance: "Số dư:",
    all: "Tất cả",
    amountPlaceholder: "Vui lòng nhập",
    minimumWithdrawal: "Số tiền rút tối thiểu: {amount} USDT",
    fee: "Phí",
    confirm: "Xác nhận",
    confirmTitle: "Xác nhận hành động",
    confirmContent: "Bạn có chắc chắn muốn tiếp tục không?",
    toasts: {
      fetchFailed: "Tải tài sản thất bại",
      enterAddress: "Vui lòng nhập địa chỉ rút tiền",
      enterValidAmount: "Vui lòng nhập số tiền rút hợp lệ",
      insufficientBalance: "Số dư không đủ",
      minimumAmount: "Số tiền rút tối thiểu là {amount} USDT",
      processing: "Đang xử lý...",
      success: "Rút tiền thành công!",
      requestSuccess: "Yêu cầu rút tiền thành công",
      requestFailed: "Rút tiền thất bại, vui lòng thử lại",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "Nạp tiền",
    connectPrompt: "Vui lòng kết nối ví của bạn để nạp tiền",
    loading: "Đang tải...",
    depositAddress: "Địa chỉ nạp tiền",
    minimumDeposit: "*Nạp tối thiểu 10.0000 USDT",
    depositAmount: "Số tiền nạp",
    balance: "Số dư",
    amaBalance: "Số dư TAKER",
    amount: "Số tiền",
    amountPlaceholder: "Nhập số tiền nạp",
    minimumNotice: "*Tối thiểu {min} {token}",
    processing: "Đang xử lý...",
    confirm: "Xác nhận nạp tiền",
    confirmTitle: "Xác nhận hành động",
    confirmContent: "Bạn có chắc chắn muốn tiếp tục không?",
    helpText: "Nạp tiền sẽ gọi phương thức recharge của hợp đồng thông minh, cần phê duyệt token TAKER trước",
    toasts: {
      copySuccess: "Sao chép thành công",
      dataLoadFailed: "Tải dữ liệu thất bại",
      enterValidAmount: "Vui lòng nhập số tiền nạp hợp lệ",
      invalidAmount: "Số tiền nạp không được ít hơn {min} TAKER",
      invalidAddress: "Địa chỉ nạp tiền không hợp lệ",
      checkingAllowance: "Đang kiểm tra hạn mức...",
      approving: "Đang phê duyệt...",
      approveSuccess: "Phê duyệt thành công",
      depositing: "Đang nạp tiền...",
      depositSuccess: "Nạp tiền thành công",
      depositFailed: "Nạp tiền thất bại",
      balanceLoadFailed: "Không đọc được số dư USDT test. Hãy làm mới và thử lại",
      contractError: "Gọi hợp đồng thất bại, vui lòng kiểm tra số dư",
      userCancelled: "Bạn đã hủy thao tác",
      insufficientFunds: "Số dư không đủ",
      wrongNetwork: "Vui lòng chuyển sang mạng đúng",
      requestingAuth: "Đang yêu cầu ủy quyền ví...",
      waitingConfirmation: "Đang chờ xác nhận giao dịch...",
      transactionFailed: "Khởi tạo giao dịch thất bại",
      transactionCancelled: "Bạn đã hủy giao dịch",
      genericError: "Giao dịch thất bại",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "Đội của tôi",
    contractEarnings: "Thu nhập hợp đồng của tôi",
    btcFund: "Lợi nhuận tài chính",
    stats: {
      teamSubscribed: "Stake đội",
      personalSubscribed: "Stake cá nhân",
      totalTeam: "KL đội",
      periodTeam: "LN đội",
      periodPersonal: "KL cá nhân",
      personalEarnings: "LN tích lũy cá nhân",
      teamEarnings: "LN đội",
      personalVolume: "KL cá nhân",
      teamVolume: "KL đội",
      personalPower: "Sức mạnh cá nhân",
      teamTotalPower: "Tổng sức mạnh nhóm"
    },
    links: {
      invite: "Mời bạn bè",
      details: "Chi tiết nhóm"
    },
    inviteBannerTitle: "Mời bạn bè mở khóa hoa hồng đội",
    inviteBannerSubtitle: "Mở khóa hoa hồng đội của bạn",
    inviteBannerCta: "Tham gia ngay",
    unclassifiedHint: "Nguồn bồi thường lịch sử cần đối chiếu: {amount} {asset}"
  },
  my: {
    headerTitle: "Của tôi",
    login: "Nhấn để đăng nhập",
    inviteCode: "Mã mời:",
    groups: {
      common: "Chức năng chung",
      trading: "Giao dịch",
      finance: "Tài chính",
      help: "Trợ giúp"
    },
    features: {
      invite: "Mời bạn bè",
      team: "Đội của tôi",
      insurance: "Bảo hiểm hợp đồng sự kiện",
      contract: "Hợp đồng sự kiện",
      exchange: "Hoán đổi",
      fund: "Quỹ kho bạc AI",
      communitySquare: "Quảng trường cộng đồng",
      createEvent: "Tạo sự kiện",
      community: "Cộng đồng chính thức",
      terms: "Điều khoản dịch vụ",
      announcement: "Thông báo",
      privacy: "Chính sách bảo mật",
      aboutUs: "Về chúng tôi"
    }
  },
  finance: {
    title: "Trang tài chính đang được phát triển..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "Đổi thất bại: chưa đáp ứng điều kiện",
    internalPrice: "Giá nội bộ",
    marketPrice: "Giá thị trường",
    coinBasis: "Theo coin",
    legacyBasis: "Theo coin",
    contractBasis: "Cơ sở quyết toán",
    unitPrice: "Đơn giá mua",
    quotaUsed: "Tổng mua giá nội bộ",
    quotaRemaining: "Hạn mức giá nội bộ còn lại",
    quotaHint: "Giới hạn trọn đời {limit} PANTA trên mọi gói. Tắt giá nội bộ, đáo hạn hay đổi VIP không đặt lại tổng.",
    principal: "Vốn gốc",
    principalReturn: "Vốn gốc hoàn trả khi đáo hạn",
    dailyYield: "Lợi nhuận gộp mỗi ngày",
    coinYieldHint: "Lợi nhuận ngày = vốn PANTA × lãi suất năm ÷ 360, làm tròn xuống đơn vị nhỏ nhất. Giá thay đổi không đổi số coin hợp đồng. Phân bổ theo quy tắc áp dụng.",
    legacyHint: "Hợp đồng theo coin. Hoàn vốn PANTA được quy đổi theo giá đáo hạn trong hợp đồng.",
    quotaError: "Vượt hạn mức giá nội bộ. Hãy giảm số lượng; không tự chia lệnh hay chuyển sang giá thị trường.",
    permissionChanged: "Gói không còn dành cho VIP của bạn. Danh sách đã cập nhật.",
    quoteChanged: "Giá hoặc điều kiện đã đổi. Kiểm tra báo giá mới rồi xác nhận lại.",
    quoteExpired: "Báo giá hết hạn. Làm mới và kiểm tra trước khi xác nhận.",
    retryQuote: "Làm mới báo giá",
    stakeGateTitle: "Điều kiện staking để bán PANTA",
    stakeGateBody: "VIP{vip}: staking hợp lệ {staked} PANTA; cần {required} PANTA; thiếu {shortfall} PANTA. Chỉ hạn chế bán, không ảnh hưởng mua.",
    goStake: "Đến staking",
    refreshEligibility: "Làm mới điều kiện",
  },
  fundPage: {
    heroTitle: "Phát thưởng PANTA mỗi ngày",
    heroDesc: "Đăng ký quỹ Galaxy để nhận cổ tức theo năm",
    learnMore: "Tìm hiểu thêm",
    allProducts: "Tất cả sản phẩm",
    subscribe: "Đăng ký",
    stake: "Staking",
    stakePreview: "Xem trước staking",
    searchCoin: "Tìm coin",
    allPeriods: "Tất cả kỳ hạn",
    colCoin: "Tên quỹ",
    colApy: "APY theo coin",
    colTerm: "Kỳ hạn",
    fixedTerm: "Kỳ hạn cố định",
    galaxyProduct: "Galaxy {n}",
    termLabel: "Kỳ hạn",
    apyLabel: "APY",
    stakeCap: "Nắm giữ cá nhân",
    stakeAmount: "Số lượng staking",
    estEarnings: "Lợi nhuận ước tính",
    stakeDisclaimer: "Lợi nhuận mang tính minh họa, không đảm bảo. Khoảng 70% vào số dư khả dụng, 30% vào quỹ trải nghiệm; quỹ trải nghiệm mở khóa sau khoảng 3 lần doanh số.",
    stakeSuccess: "Staking thành công",
    annualized: "APY tham khảo",
    perShareYield: "Lợi nhuận / 10k (WBS)",
    dayUnit: "ngày",
    empty: "Chưa có sản phẩm quỹ",
    loadFailed: "Tải thất bại",
    rulesTitle: "Thông tin quỹ",
    gotIt: "Đã hiểu",
    pantaAvailable: "PANTA khả dụng",
    activeFaceValue: "Phần đang đầu tư",
    totalReward: "Lợi nhuận quỹ tích lũy (PANTA)",
    fundYieldUnavailable: "--/Vui lòng cập nhật dịch vụ",
    effectiveVip: "Hạng hiệu lực",
    myHoldings: "Lịch sử mua quỹ",
    faceValue: "Giá trị",
    maturity: "Đáo hạn",
    stakeStart: "Thời gian staking",
    pantaPrice: "Đơn giá PANTA",
    noMoreHoldings: "Không còn vị thế",
    subscriptionStatus: {
      ACTIVE: "Đang hoạt động",
      SETTLED: "Đã tất toán",
      CANCELLED: "Đã hủy",
      MANUAL_REVIEW: "Duyệt thủ công",
    },
    minPanta: "Tối thiểu PANTA",
    pantaAmount: "Số lượng đăng ký (PANTA)",
    stepHint: "Bội số của {step}, tối thiểu {min}",
    getQuote: "Lấy báo giá",
    confirmStake: "Xác nhận staking",
    jouleDebit: "Trừ JOULE",
    expectedPanta: "PANTA staking",
    quoteExpires: "Báo giá hết hạn",
    unavailable: "Chưa mở",
    invalidAmount: "Nhập số lượng PANTA đúng bước",
    quoteFailed: "Báo giá thất bại",
    rewards: "Phần thưởng quỹ",
    unlock: "Lô PANTA đóng băng",
    unlockProgress: "Khối lượng giao dịch đã dùng",
    pantaLedger: "Sổ cái PANTA"
  },
  finanfund: {
    title: "Quỹ Tài Chính TAKER",
    subtitle: "Đơn giản, Hiệu quả, Kiếm tiền dễ dàng",
    productName: "Quỹ Tài Chính TAKER",
    minAmount: "Số tiền tối thiểu",
    incomeRatio: "Tỷ lệ thu nhập",
    lockPeriod: "Thời gian khóa",
    dailyReturn: "Lợi nhuận hàng ngày",
    earning: "Đã kiếm",
    redemptionRules: "Quy tắc hoàn trả",
    rules: {
      rule1: "Quỹ Tài Chính TAKER không thể hoàn trả sau khi ủy thác",
      rule2: "Thu nhập hàng ngày được tự động ghi có",
      rule3: "Số tiền khóa sẽ được trả lại sau khi kết thúc thời gian khóa"
    },
    subscription: "Đăng ký",
    amountPlaceholder: "Nhập số tiền",
    balance: "Số dư",
    availableFunds: "Quỹ khả dụng",
    all: "Tất cả",
    subscribeButton: "Đăng ký",
    toasts: {
      productIdNotExist: "ID sản phẩm không tồn tại",
      enterValidAmount: "Vui lòng nhập số tiền đăng ký hợp lệ",
      minAmountRequired: "Số tiền đăng ký không được thấp hơn {amount} USDT",
      subscribeSuccess: "Đăng ký thành công",
      subscribeFailed: "Đăng ký thất bại"
    }
  },
  community: {
    title: "Cộng đồng chính thức",
    bannerTitle1: "Tham gia cộng đồng của chúng tôi",
    bannerTitle2: "Kết nối với người dùng toàn cầu",
    linkCopied: "Đã sao chép liên kết"
  },
  invite: {
    headerTitle: "Mời bạn bè",
    rulesEntry: "Quy tắc mời",
    subtitle: "Kiếm từ mọi giao dịch của đội",
    mainTitle: "Mời & Kiếm",
    description: "Chia sẻ link — bạn bè giao dịch, bạn nhận thưởng",
    yourCode: "Mã mời",
    shareLink: "Liên kết chia sẻ",
    inviteButton: "Mời bạn bè",
    subTitle: "Nhận hoa hồng cao",
    viewRules: "Xem quy tắc",
    rulesLink: "Xem quy tắc giới thiệu >",
    rulesTitle: "Quy tắc giới thiệu",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "Mời bạn bè",
    referralCode: "Mã giới thiệu",
    inviteLink: "Liên kết mời",
    loading: "Đang tải...",
    copyButton: "Sao chép liên kết mời",
    toasts: {
      emptyContent: "Nội dung trống",
      copySuccess: "Sao chép thành công",
      bindSuccess: "Liên kết thành công",
      bindFailed: "Liên kết thất bại",
      alreadyBound: "Đã liên kết cấp trên; không thể đổi",
      loginFirst: "Vui lòng kết nối ví trước",
      invalidCode: "Nhập mã mời hoặc địa chỉ ví hợp lệ",
      cannotBindSelf: "Không thể liên kết chính mình",
    },
    boundLabel: "Đã gắn cấp trên",
    modalDesc: "Chưa gắn cấp trên. Nhập mã mời hoặc địa chỉ ví để tham gia thưởng đội. Thông tin từ link mời được điền sẵn; nếu không có sẽ dùng địa chỉ cấp trên mặc định.",
    bindPlaceholder: "Nhập mã mời hoặc địa chỉ ví",
    bindButton: "Gắn",
    binding: "Đang gắn…",
    bindSuperior: "Gắn cấp trên",
  },
  market: {
    title: "Thị trường",
    banner: {
      title: "Hợp đồng sự kiện",
      desc: "Giải phóng tiềm năng thu nhập on-chain"
    },
    tabs: {
      main: "Coin chính",
      rise: "Top tăng giá"
    },
    types: {
      crypto: "Tiền điện tử",
      stocks: "Cổ phiếu Mỹ",
      forex: "Ngoại hối",
      commodities: "Hàng hóa",
      favorites: "Yêu thích"
    },
    headers: {
      pair: "Cặp giao dịch",
      price: "Giá mới nhất",
      change: "Biến động hôm nay"
    },
    loading: "Đang tải...",
    loadingMore: "Đang tải thêm...",
    noMoreData: "Không còn dữ liệu"
  },
  notice: {
    loginRequired: "Vui lòng đăng nhập để xem thông báo",
    empty: "Chưa có thông báo",
    unpublished: "Đã gỡ",
    title: "Thông báo",
    helpCenter: "Trung tâm trợ giúp",
    noticeDetail: "Chi tiết thông báo",
    viewDetail: "Xem chi tiết",
    pdfViewer: "Trình xem PDF",
    videoPlayer: "Trình phát video",
    imageViewer: "Trình xem hình ảnh",
    documentViewer: "Trình xem tài liệu",
    clickToViewPdf: "Nhấp để xem PDF",
    clickToViewDocument: "Nhấp để xem tài liệu",
    openInBrowser: "Mở trong trình duyệt",
    tryingViewer: "Đang thử phương pháp {current}/{total}",
    pdfLoadFailed: "Tải xem trước PDF thất bại, vui lòng tải xuống để xem",
    downloadPdf: "Tải PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "Hợp đồng sự kiện",
    nextRound: "Vòng tiếp theo",
    posCurrent: "Hiện tại",
    aiThenPrefix: 'AI lúc đó: ',
    aiUnlinked: 'Chưa liên kết AI',
    aiNotRecorded: 'Chưa ghi nhận',
    insuranceLabel: "Bảo hiểm",
    insuranceNotSelected: 'Chưa chọn',
    insuranceInactive: "Chưa hiệu lực",
    insuranceTypeNone: "Chưa hiệu lực",
    insuranceTypeEvent: "Bảo hiểm thường đã bật",
    insuranceTypeEventShort: "Bảo hiểm thường",
    insuranceTypeAi: "Bảo hiểm AI đã bật",
    insuranceTypeAiShort: "Bảo hiểm AI",
    insuranceTypeConverted: "Đơn này đã chuyển sang bảo hiểm thường",
    insuranceTypeUnknown: "Trạng thái bảo hiểm chờ xác nhận",
    inProgress: "Đang diễn ra",
    estimatedPnl: "Lãi lỗ ước tính",
    settlementConfirming: "Đang xác nhận kết quả",
    balanceSyncing: "Đang đồng bộ số dư",
    pendingReview: "Chờ đối soát",
    connecting: "Đang kết nối...",
    connectWallet: "Kết nối",
    orderDetail: {
      title: "Chi tiết lệnh",
      orderId: "Mã lệnh",
      symbol: "Cặp",
      interval: "Chu kỳ",
      direction: "Hướng",
      aiDirection: "AI lúc đó",
      openTime: "Thời gian mở",
      settleTime: "Hết hạn",
      settledAt: "Thời gian tất toán",
      openPrice: "Giá mở",
      closePrice: "Giá đóng",
      stake: "Vốn",
      premium: "Phí bảo hiểm",
      netProfit: "Lãi/lỗ ròng",
      status: "Trạng thái",
      orderSource: "Nguồn lệnh",
      converted: "Chuyển đổi bảo hiểm",
      notRecorded: "Chưa ghi nhận",
      copied: "Đã sao chép mã lệnh",
    },
    orderStatus: {
      CREATED: "Đã tạo",
      ACCEPTED: "Đã chấp nhận",
      CLOSED: "Đã đóng",
      FUNDS_LOCKED: "Đã khóa vốn",
      AWAITING_SETTLEMENT: "Chờ tất toán",
      PROCESSING: "Đang xử lý",
    },
    insuranceBalanceInsufficient: "Số dư tài khoản bảo hiểm không đủ",
    mainBalanceInsufficient: "Số dư tài khoản chính không đủ",
    insuranceBalanceRequired: "Số dư bảo hiểm không đủ; không thể bật bảo hiểm",
    insuranceRulesUnavailable: "Quy tắc phí bảo hiểm chưa sẵn sàng; không thể bật bảo hiểm",
    insuranceMainRequired: "Số dư tài khoản chính không đủ; không thể bật bảo hiểm",
    preferenceLoading: "Đang tải cài đặt bảo hiểm",
    preferenceLoadFailed: "Tải cài đặt bảo hiểm thất bại; nhấn để thử lại",
    preferenceSaveFailed: "Lưu cài đặt bảo hiểm thất bại; thử lại",
    preferenceSessionEndedSaveFailed: "Vòng đã kết thúc nhưng cài đặt tắt chưa được lưu",
    premiumEstimate: "Phí bảo hiểm ước tính {premium} JOULE ({rate}%)",
    premiumShortfallHint: "Tài khoản bảo hiểm còn thiếu {amount} JOULE",
    premiumEstimateUnavailable: "Chưa thể ước tính phí bảo hiểm",
    premiumBoundEstimate: "Phí bảo hiểm ước tính chiến lược đã liên kết {premium} JOULE",
    insuranceConfirmTitle: "Xác nhận phí bảo hiểm",
    insuranceConfirmBody: "Xem trước phí bảo hiểm {premium} JOULE. Bản xem trước là kết quả cuối. Xác nhận để gửi.",
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "Mua",
      sell: "Bán"
    },
    holdings: {
      current: "Vị thế",
      history: "Lịch sử giao dịch",
      currentCount: "Vị thế đang mở {n}",
      empty: "Không có vị thế",
      historyEmpty: "Không có lịch sử"
    },
    position: {
      openPrice: "Giá mở",
      closePrice: "Giá đóng",
      profitLoss: "Lãi/Lỗ",
      countdown: "Thanh toán sau",
      calculating: "Đang tính...",
      settled: "Đã thanh toán",
      settling: "Đang thanh toán",
      active: "Hoạt động",
      settledAt: "Thanh toán lúc"
    },
    modal: {
      amountPlaceholder: "Nhập số tiền"
    },
    pairSelector: {
      title: "Chọn cặp giao dịch",
      searchPlaceholder: "Tìm kiếm coin"
    },
    errors: {
      dataNotReady: "Đang tải dữ liệu, vui lòng đợi"
    },
    marketPause: {
      default: "Thị trường tạm thời không khả dụng. Vui lòng thử lại sau.",
      lastPriceStreamWarming: "Nguồn giá mới nhất đang chuẩn bị. Vui lòng thử lại sau.",
      marketWarming: "Thị trường đang khởi động. Vui lòng thử lại sau.",
      recovering: "Thị trường đang khôi phục. Vui lòng thử lại sau.",
      clockNotSynced: "Đồng hồ máy chủ chưa đồng bộ. Vui lòng thử lại sau.",
      symbolUnavailable: "Cặp giao dịch này chưa mở"
    },
    toasts: {
      connectSuccess: "Kết nối thành công",
      connectCancelled: "Bạn đã hủy kết nối",
      connectFailed: "Kết nối thất bại"
    },
    openPriceLabel: "Giá mở",
    secondsUnit: "s",
    amountLabel: "Số tiền",
  },
  wallet: {
    title: "Ví của tôi",
    address: "Địa chỉ ví",
    addressCopied: "Đã sao chép địa chỉ",
    inviteCode: "Mã mời",
    logout: "Đăng xuất",
    login: "Đăng nhập",
    toasts: {
      networkSwitchCancelled: "Người dùng đã hủy chuyển mạng",
      networkConfigNotFound: "Không tìm thấy cấu hình mạng cho {chainId}",
      signatureCancelled: "Người dùng đã hủy chữ ký",
      connectionFailed: "Kết nối ví thất bại",
      accountSwitched: "Tài khoản ví đã thay đổi, vui lòng kết nối lại",
      connectionTimedOut: "Kết nối hết thời gian, vui lòng thử lại",
      loginSuccess: "Đăng nhập thành công",
      logoutSuccess: "Đăng xuất thành công",
      switchNetwork: "Vui lòng chuyển sang {chainName} trong ví của bạn trước khi cố gắng gửi tiền",
      wrongChain: "Mạng không được hỗ trợ, vui lòng chuyển sang {chainName}",
      switchingNetwork: "Đang chuyển mạng...",
      switchNetworkFailed: "Chuyển mạng thất bại, vui lòng chuyển thủ công sang {chainName} trong ví của bạn"
    }
  },
  exchange: {
    title: "Hoán đổi nhanh",
    from: "Từ",
    to: "Đến",
    balance: "Số dư",
    all: "Tất cả",
    placeholder: "Vui lòng nhập",
    fee: "Phí",
    minAmount: "Số tiền hoán đổi tối thiểu: {amount} {symbol}",
    button: "Hoán đổi",
    tradeButton: "Giao dịch",
    paymentCurrency: "Tiền tệ thanh toán",
    estimatedGasFee: "Phí Gas ước tính",
    gasPaymentNote: "Sẽ sử dụng số dư GetGas để thanh toán phí Gas",
    slippage: "Trượt giá",
    auto: "Tự động",
    approximately: "Khoảng",
    minReceived: "Nhận tối thiểu",
    exchangeRate: "Tỷ giá",
    finalAmount: "Số tiền cuối cùng",
    confirm: "Xác nhận",
    swapSuccess: "Hoán đổi nhanh thành công!",
    swapping: "Đang hoán đổi...",
    confirmTitle: "Xác nhận hành động",
    confirmContent: "Bạn có chắc chắn muốn tiếp tục không?",
    toasts: {
      fetchFailed: "Tải tài sản thất bại",
      enterValidAmount: "Vui lòng nhập số tiền hợp lệ",
      swapSuccess: "Hoán đổi thành công",
      requestFailed: "Yêu cầu thất bại",
      insufficientBalance: "Số dư không đủ, không thể hoán đổi",
      minAmount: "Minimum swap amount is {amount} {symbol}",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "Phí Joule → USDT {fee}",
    configLimits: "Phí {fee} · Hạn mức giá trị trước trừ {min}–{max} U",
    unlimited: "Không giới hạn",
    quoteFailed: "Không lấy được báo giá, vui lòng thử lại"
  },
  globalNode: {
    title: "Nút Toàn Cầu"
  },
  eventInsurance: {
    title: "Bảo Hiểm Hợp Đồng Sự Kiện",
    availableBalance: "Số Dư Khả Dụng (USDT)",
    fundTransfer: "Chuyển Tiền",
    fundHistory: "Lịch Sử Tiền",
    type: "Loại: ",
    all: "Tất Cả",
    transfer: "Chuyển",
    fundTransferTitle: "Chuyển Tiền",
    currency: "Tiền Tệ",
    from: "Từ",
    to: "Đến",
    availableAccount: "Tài Khoản Khả Dụng",
    contractInsuranceAccount: "Tài Khoản Bảo Hiểm Hợp Đồng",
    pleaseEnter: "Vui lòng nhập",
    confirmTransfer: "Xác Nhận Chuyển",
    insufficientBalance: "Số dư không đủ",
    transferSuccess: "Chuyển thành công",
    transferFailed: "Chuyển thất bại",
    transferring: "Đang chuyển...",
    noRecords: "Không có bản ghi",
    selectAccount: "Chọn tài khoản",
    cannotTransferToSameAccount: "Không thể chuyển đến cùng một tài khoản",
    cannotTransferContractAccount: "Không hỗ trợ chuyển tài khoản hợp đồng",
    contractAccount: "Tài khoản hợp đồng (TAKER)",
    rulesTab: "Tóm tắt",
    agreementTab: "Thỏa thuận đầy đủ",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "I. Quy tắc dự đoán hợp đồng sự kiện",
      eventOpen: {
        title: "1. Bật bảo hiểm",
        points: [
          "Khi bật BH, phí theo tỷ lệ lệnh/số dư: ≤10% số dư → 15%; vượt → 20%.",
          "Nếu số dư tài khoản BH không đủ, BH không có hiệu lực"
        ]
      },
      eventLimit: {
        title: "2. Ngưỡng đặt lệnh",
        points: [
          "Tối đa mỗi lệnh 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. Quy tắc quyền bồi thường",
        ok: [
          "50% bồi thường vào hạn mức airdrop cá nhân; đủ 50 USD được 1 node",
          "30% vào hạn mức cộng đồng theo VIP; đủ 50 USD được 1 node"
        ],
        fail: [
          "Mất toàn bộ vốn cược; kết thúc dự đoán"
        ]
      },
      eventPool: {
        title: "4. Bồi thường pool BH sự kiện:",
        points: [
          "2% tài sản pool/ngày bằng PANTA airdrop theo trọng số node",
          "Khi airdrop ngày đạt 50 USD PANTA thì giảm 1 node"
        ]
      },
      eventProfit: {
        title: "5. Quy tắc lãi/lỗ",
        points: [
          "Đúng: vốn 100% + lãi (80%)",
          "Sai: mất toàn bộ vốn; kết thúc"
        ]
      },
      aiGroup: "II. Quy tắc dự đoán AI",
      aiFirst: {
        title: "1. Lệnh đầu cần nhập thủ công"
      },
      aiOpen: {
        title: "2. Bật bảo hiểm",
        points: [
          "Khi bật BH, trả phí 5%–10% số tiền vị thế",
          "Nếu số dư BH không đủ, BH không hiệu lực"
        ]
      },
      aiLimit: {
        title: "3. Giới hạn đặt lệnh",
        points: [
          "Số tiền theo bảng vị thế; hướng khớp tín hiệu AI",
          "Không theo bảng → chuyển dự đoán sự kiện thường",
          "Thua liên tiếp 8 lệnh → quyền bồi thường theo tỷ lệ",
          "Lệnh thắng reset chuỗi về bước 1"
        ]
      },
      table: {
        level: "Hạng TK",
        order1: "Lệnh1",
        order2: "Lệnh2",
        order3: "Lệnh3",
        order4: "Lệnh4",
        order5: "Lệnh5",
        order6: "Lệnh6",
        order7: "Lệnh7",
        order8: "Lệnh8"
      },
      claimOk: "Đủ điều kiện bồi thường",
      claimFail: "Không đủ điều kiện",
      claimFailWhen: "Khi không đủ điều kiện:",
      claimPrereq: "Điều kiện tiên quyết:",
      aiClaim: {
        title: "4. Cơ chế quyền bồi thường",
        prereq: [
          "BH đã bật",
          "Hướng khớp AI",
          "Số tiền/thứ tự theo bảng",
          "Đủ điều kiện tất toán"
        ],
        ok: [
          "Bồi thường tiền = lỗ lũy kế × 90%"
        ],
        fail: [
          "Mất toàn bộ vốn; kết thúc"
        ]
      },
      aiProfit: {
        title: "5. Quy tắc lãi",
        points: [
          "Đúng: vốn 100% + lãi 80%",
          "Sai: mất vốn; kết thúc hoặc bồi thường"
        ]
      }
    },
    rulesContent: "PANTA Market Thỏa thuận Bảo hiểm Kế hoạch Bảo vệ Giao dịch Hợp đồng Sự kiện\n\n【Thông báo quan trọng】Trước khi sử dụng dịch vụ này, vui lòng đọc kỹ và hiểu đầy đủ toàn bộ nội dung thỏa thuận. Hệ thống sẽ coi việc người dùng bật 「Công tắc bảo hiểm」 là bạn đã đọc, hiểu và chấp nhận đầy đủ thỏa thuận cùng các phụ lục, xác nhận thỏa thuận có ràng buộc pháp lý và đồng ý tuân thủ nghiêm ngặt; nếu không đồng ý và không chấp nhận, vui lòng ngay lập tức ngừng sử dụng kế hoạch bảo vệ này.\n\nĐiều 1: Tổng tắc và Phạm vi áp dụng\n\n1.1 Thỏa thuận này dùng để giải thích cách tham gia, thành lập lệnh, phí, xác định kết quả, thanh toán quỹ, bồi thường có điều kiện và quyền lợi nút liên quan cùng chức năng dự đoán sự kiện của hai loại tính năng 「Dự đoán hợp đồng sự kiện」 và 「Dự đoán hợp đồng sự kiện AI」 trong PANTA Market. Hai sản phẩm lần lượt áp dụng các điều khoản chuyên biệt, không thể trực tiếp áp dụng mức phí, điều kiện bồi thường hoặc quy tắc nút của một sản phẩm sang sản phẩm kia.\n1.2 Dự đoán hợp đồng sự kiện là chức năng người dùng đưa ra phán đoán về sự kiện đã liệt kê trước và các kết quả có thể chọn, sử dụng JOULE để gửi và tạo lệnh. Khoản lỗ đủ điều kiện cuối cùng có thể theo quy tắc đã phê duyệt tạo hạn mức nút cá nhân hoặc nút đội cộng đồng; hạn mức đó không phải bồi thường tiền mặt tức thì. Dự đoán hợp đồng sự kiện AI là chức năng người dùng tham khảo tín hiệu hướng dự đoán AI hợp lệ do hệ thống cung cấp, theo số tiền cố định và trật tự của phương án đã chọn, xác nhận tham gia từng lệnh để tạo lệnh. Khi 8 lệnh của cùng một chuỗi đủ điều kiện được thanh toán đầy đủ và tất cả đều lỗ, đồng thời thỏa mãn các điều kiện rõ ràng khác, bồi thường JOULE được tính theo 90% tổng vốn gốc đủ điều kiện. Tín hiệu AI không phải bảo đảm kết quả, bồi thường có điều kiện cũng không bao phủ toàn bộ chi phí.\n1.3 Thỏa thuận này, tham số phiên bản hóa của sản phẩm tương ứng, quy tắc sự kiện cụ thể và trang xác nhận người dùng cùng cấu thành quy tắc hoàn chỉnh. Trang chỉ được hiển thị các tham số đã phê duyệt, không được dùng 「lấy trang làm chuẩn」 để thay thế việc thiếu điều kiện then chốt. Khi có mâu thuẫn giữa các tài liệu, phải dừng giao dịch mới bị ảnh hưởng và giải thích, kiểm tra và sửa chữa, không được sau đó đơn phương chọn cách giải thích bất lợi hơn cho người dùng để xử lý lệnh hiện có.\n1.4 Dự án này liên quan tài sản thực, dự đoán sự kiện, bồi thường có điều kiện và danh xưng bảo hiểm, thưởng đội, quy đổi và quỹ, không thuộc loại sản phẩm có thể bỏ qua đánh giá tuân thủ kiểm soát rủi ro. Tính chất pháp lý, giấy phép, khu vực cung cấp, tư cách người dùng, chống rửa tiền, bảo vệ người tiêu dùng và yêu cầu xử lý dữ liệu của từng chức năng phải hoàn thành xác minh chuyên nghiệp theo phạm vi dịch vụ thực tế. Điều khoản miễn trừ trách nhiệm không thể thay thế giấy phép cần thiết, sắp xếp quỹ và biện pháp kiểm soát; bản thảo này không giả định áp dụng luật của một quốc gia cụ thể, cũng không xác định sản phẩm đã được phép vận hành hợp pháp.\n\nĐiều 2: Thuật ngữ và Trạng thái quỹ\n\n2.1 JOULE là đơn vị dùng để đo vốn gốc dự đoán, phí bảo hiểm và bồi thường AI trong thiết kế sản phẩm này; PANTA là đơn vị tài sản dùng cho phân bổ quyền lợi nút và các nghiệp vụ khác; giá trị tương đương USDT là tiêu chí đo lường dùng cho một phần hạn mức và tính toán giá trị. Ba loại không được trộn lẫn, hiển thị số nội bộ không có nghĩa có thể quy đổi ngay sang tiền pháp định theo tỷ giá cố định, cũng không đồng nghĩa chuyển giao tài sản trên chuỗi đã hoàn tất; giải thích này không hủy bỏ quyền lợi tài sản hoặc nghĩa vụ thanh toán đã hình thành theo pháp luật và hợp đồng.\n2.2 Vốn gốc đặt lệnh là số JOULE người dùng thực sự xác nhận và được hệ thống chấp nhận trong một lệnh, không bao gồm phí bảo hiểm. Phí bảo hiểm là chi phí tính theo quy tắc áp dụng cho lệnh đó. Tổng đóng băng thường là tổng vốn gốc và phí bảo hiểm, nếu có chi phí khác phải tiết lộ riêng trước, không được thêm phí chưa xác nhận khi thanh toán.\n2.3 Số dư khả dụng là số dư có thể dùng cho thao tác mới theo quy tắc tài khoản hiện tại. Số dư đóng băng là số dư đã dự trữ cho lệnh được chấp nhận hoặc nghiệp vụ được phê duyệt, tạm thời không dùng cho thao tác khác. Lợi nhuận dự kiến, bồi thường chờ duyệt, hạn mức nút và phân bổ chưa ghi sổ đều không tính vào số dư khả dụng. Hiển thị số dư phải ghi rõ tên tài sản, không cho phép cộng trực tiếp số lượng tài sản khác nhau.\n2.4 Chuỗi AI là hồ sơ nghiệp vụ liên tiếp từ lệnh thứ 1 theo quy tắc đối với cùng một phương án đã xác nhận. Bước hiện tại, kết quả lệnh và bằng chứng đủ điều kiện do máy chủ duy trì. Mất mạng bình thường hoặc thoát APP không cấu thành chấm dứt nghiệp vụ chuỗi; reset là chấm dứt chuỗi cũ sau khi thỏa mãn điều kiện quy định trong thỏa thuận này.\n2.5 Hạn mức nút sức mạnh tính toán là đơn vị ghi sổ tương đương USDT tích lũy theo quy tắc dựa trên khoản lỗ đủ điều kiện cuối cùng, dùng để tạo nút. Nút là hồ sơ tư cách tham gia phân bổ quyền lợi sau này, không phải tiền mặt tức thì, PANTA đã vào tài khoản, cũng không vì tên gọi mà trở thành NFT trên chuỗi có thể giao dịch, stake hoặc chuyển nhượng tự do.\n2.6 Ảnh chụp quy tắc là phiên bản quy tắc, tham số, số tiền, căn cứ giá, điều khoản và bằng chứng liên quan được lưu khi xác nhận lệnh hoặc chuỗi. Phiên bản mới phát hành không thể ghi đè ảnh chụp cũ. Hồ sơ máy chủ dùng để kiểm tra trạng thái thao tác, nhưng người dùng có thể cung cấp bằng chứng khác để xin xem xét lại, không thể chỉ vì hồ sơ do nền tảng lưu giữ mà loại trừ khiếu nại hợp lý.\n\nĐiều 3: Tư cách sử dụng và Xác nhận thỏa thuận\n\n3.1 Nền tảng chỉ có thể cung cấp chức năng tương ứng cho người dùng trong khu vực dịch vụ, độ tuổi và phạm vi phù hợp đã được phê duyệt. Phiên bản chính thức phải làm rõ yêu cầu xác minh danh tính, phạm vi sản phẩm khả dụng và lý do hạn chế. Không thể chỉ dựa vào ví người dùng đã kết nối, giao diện hiển thị hoặc tài khoản có số dư để xác định họ đủ tư cách tham gia tất cả sản phẩm.\n3.2 Người dùng phải sử dụng tài khoản và tài sản do bản thân có quyền kiểm soát, không được mạo danh, sử dụng tài khoản người khác trái phép, giả mạo tài liệu tư cách, thao túng tín hiệu hoặc bằng chứng kết quả. Khi nền tảng cần xác minh bổ sung, phải giải thích tài liệu cần thiết và mục đích nghiệp vụ; hạn chế tham gia mới và xử lý thực hiện lệnh hiện có phải được giải thích riêng.\n3.3 Trước khi đặt lệnh, người dùng phải có thể xem vốn gốc, phí bảo hiểm, chi phí bổ sung có thể phát sinh, tùy chọn dự đoán, tổn thất tồi nhất, điều kiện thanh toán, nguồn xác định và đường dẫn tranh chấp. Nền tảng phải cung cấp bước xác nhận rõ ràng, không được thay thế xác nhận thực sự của người dùng bằng đồng ý mặc định, phí ẩn, tự động chuyển số tiền hoặc thúc giục thao tác lặp lại.\n3.4 Tín hiệu AI, kết quả lịch sử, lợi nhuận ví dụ, quy mô pool nút và hồ sơ quyền lợi của người khác đều không cấu thành cam kết kết quả tương lai. Người dùng có thể mất vốn gốc lệnh đã chấp nhận và phí bảo hiểm liên quan, quyền lợi nút cũng có thể bị ảnh hưởng bởi số dư pool, trọng số hiệu lực, giá và trạng thái xử lý. Người dùng không nên coi một ví dụ cụ thể là thu nhập cố định hoặc thời hạn thu hồi xác định của bản thân.\n\nĐiều 4: Quy tắc dự đoán hợp đồng sự kiện\n\n4.1 Trước khi bắt đầu chuỗi AI, người dùng phải xem phương án khả dụng, vốn gốc vị thế thực hiện, phí bảo hiểm dự kiến, tổng nhu cầu quỹ, thời hạn hiệu lực tín hiệu, quy tắc thanh toán 60 giây và điều kiện bồi thường 90%. Chuỗi mới chỉ có thể bắt đầu từ lệnh thứ 1, không được chuyển phương án trong khi chuỗi đang diễn ra; người dùng không thể dùng bỏ bước, đổi số tiền hoặc lệnh chưa kết song song để ghép thành chuỗi đủ điều kiện mới. Sau khi người dùng chọn kết quả sự kiện và nhập vốn gốc JOULE, nền tảng tính phí bảo hiểm theo cơ số vị thế đã phê duyệt. Thiết kế hiện tại: khi vốn gốc không vượt quá 10% cơ số vị thế, phí bảo hiểm là 15% vốn gốc; khi vượt quá 10% cơ số vị thế, phí bảo hiểm là 20% vốn gốc. Đúng ranh giới 10% áp dụng 15%.\n4.2 Tín hiệu AI phải hiển thị đối tượng, hướng, thời gian, thời hạn hiệu lực và mã tín hiệu có thể nhận dạng. Khi đặt lệnh, người dùng phải xác nhận hướng khớp với tín hiệu hợp lệ tại thời điểm đó. Tín hiệu cập nhật trong thời gian chờ hoặc kết nối lại phải được kiểm tra lại; tín hiệu hết hạn không thể tiếp tục dùng qua bộ nhớ đệm client. Việc áp dụng tín hiệu AI không có nghĩa nền tảng hoặc thuật toán biết kết quả tương lai. Độ chính xác lịch sử, bản ghi demo và giải thích dự đoán không thể làm bảo đảm kết quả lệnh này. Nền tảng không được dùng biểu đạt như 「chắc thắng」「lời chắc chắn」 hoặc 「sai cũng không mất」 để thay thế vốn gốc, phí bảo hiểm và điều kiện bồi thường thực tế.\n4.3 Mỗi sự kiện phải liệt kê độc lập tên, mô tả sự thật, kết quả có thể chọn, thời điểm mở và đóng, múi giờ, hạn mức tham gia, tiêu chuẩn xác định kết quả, nguồn bằng chứng chính và dự phòng, tính lợi nhuận, tổn thất tồi nhất, quy tắc hủy hoặc hoãn và thủ tục khiếu nại. Đối với sự kiện mơ hồ, thiếu tiêu chuẩn xác định hoặc tham số kinh tế then chốt chưa phê duyệt, không được mở đặt lệnh thực. Nền tảng phải kiểm tra lại khi nhận lệnh: sự kiện vẫn mở, thời gian máy chủ trước thời điểm đóng, tùy chọn và phiên bản hợp lệ, tư cách và hạn mức người dùng đáp ứng, số dư đủ. Việc xác định đóng không lấy thời gian thiết bị người dùng làm chuẩn, cũng không lấy việc client vẫn hiển thị đếm ngược khi người dùng nhấp làm chuẩn.\n4.4 Sau khi đóng băng vốn gốc và phí bảo hiểm thành công, lệnh được chấp nhận, nền tảng trả về thời gian chấp nhận và thời điểm thanh toán đã thỏa thuận. Thời điểm đó tính theo thời gian chấp nhận máy chủ cộng 60 giây, không tính từ lúc người dùng mở trang, nhận tín hiệu hoặc nhấp nút. Độ trễ mạng không rút ngắn hoặc kéo dài tiêu chí xác định đã cố định. 60 giây biểu thị thời điểm xác định kết quả đã thỏa thuận, không cam kết hoàn tất ghi có quỹ ngay tại khoảnh khắc đếm ngược client về 0. Sau khi đến thời điểm, phải lấy bằng chứng kết quả từ nguồn đã thỏa thuận; khi không có bằng chứng, nguồn bất thường hoặc kết quả xung đột, giữ trạng thái chờ thanh toán và giải thích, không thể tự động ghi là lỗ.\n4.5 Chỉ khi đang ở chuỗi hiệu lực hiện tại, quy tắc đã hiển thị rõ, không có lệnh chưa kết, và người dùng thực sự gửi hướng không khớp tín hiệu hợp lệ hoặc số tiền không khớp bước cố định hiện tại, mới áp dụng thiết kế từ chối lệnh và reset chấm dứt chuỗi cũ. Phải hiển thị lý do cụ thể, chuỗi bị ảnh hưởng và thao tác tiếp theo có thể thực hiện, đồng thời lưu lịch sử. Sau reset, lần sau có thể xây chuỗi mới từ lệnh thứ 1, không thể nối lệnh đã lỗ của chuỗi cũ với lệnh chuỗi mới để tính 8 lần thua liên tiếp. Lãi lỗ đã hoàn thành trong chuỗi cũ được giữ, không tự động nhận bồi thường 90%; nhưng không ảnh hưởng quyền người dùng xin xem xét lại về lỗi nền tảng, reset sai hoặc tranh chấp khác.\n4.6 Yêu cầu vi phạm bị từ chối bản thân không thành giao dịch, không tạo thêm mất vốn gốc, phí bảo hiểm hoặc nút lỗ. Diễn đạt trong nguyên liệu về chuyển lỗ vi phạm thành nút chưa hình thành quy tắc thực thi, không thể dựa vào đó tạo lỗ hoặc bồi thường giả cho lệnh bị từ chối.\n4.7 Người dùng tạm dừng khởi tạo bước tiếp theo không đồng nghĩa đã hình thành 8 lần thua liên tiếp; chuỗi chưa hoàn thành không thể yêu cầu bồi thường 90% theo tỷ lệ số lệnh đã lỗ. Chấm dứt chủ động chuỗi, lưu trú dài hạn và thời hạn khôi phục cần xác nhận quy tắc chính thức, không được tự thêm thời gian hết hiệu lực chưa tiết lộ. Thoát bình thường và mất mạng không được giải thích là từ bỏ chủ động. Cùng một chuỗi phải đồng thời thỏa mãn bốn loại điều kiện sau mới tính bồi thường 90% JOULE theo thiết kế hiện tại: mỗi lệnh cơ chế bảo hiểm bật hiệu lực và vốn gốc cùng phí bảo hiểm lệnh đó thực sự đóng băng thành công; mỗi lệnh hướng khớp tín hiệu AI hợp lệ khi chấp nhận; mỗi lệnh vốn gốc và thứ tự bước phù hợp phương án đã xác nhận; 8 lệnh đều thanh toán đầy đủ và kết quả đều là lỗ đủ điều kiện. Số tiền bồi thường là tổng vốn gốc tham gia 8 lệnh đủ điều kiện nhân 90%, đo và trả bằng JOULE; phí bảo hiểm không nằm trong cơ số 90% đó. Bồi thường không thể trực tiếp diễn đạt là hoàn trả 90% toàn bộ chi phí, cũng không tự động quy đổi sang USDT, tiền mặt hoặc PANTA. Quy đổi tài sản khác vẫn cần quy tắc và ủy quyền riêng.\n4.8 Thành lập tư cách bồi thường và thanh toán thành công là hai giai đoạn. Khi đủ tư cách nhưng thiếu quỹ, sổ sách bất thường hoặc có hạn chế áp dụng, giữ nghĩa vụ và chi tiết chờ thanh toán, hiển thị đang xử lý hoặc lý do treo rõ ràng, xử lý sau theo pháp luật và hợp đồng; không được viết lại khó khăn thanh toán thành người dùng không đủ tư cách.\n4.9 Bồi thường thực hiện một lần theo hồ sơ duy nhất của chuỗi đó. Thanh toán thành công nhưng mất phản hồi, truy vấn và thử lại sau phải trả kết quả gốc, không thanh toán trùng. Thanh toán thất bại phải duy trì trạng thái chưa hoàn thành thực sự, không yêu cầu người dùng tạo chuỗi mới hoặc đặt lại để 「kích hoạt」 bồi thường gốc. Nếu cùng chuỗi theo cơ chế xác nhận trước cho phép mỗi lệnh dùng mức phí khác nhau, phải giữ ảnh chụp từng lệnh và cộng dồn chi phí thực tế; không thể đơn giản dùng một mức phí hiện tại để tính lại tất cả lệnh lịch sử. Thay đổi cơ chế mức phí ảnh hưởng chuỗi đã xác nhận phải làm rõ phạm vi áp dụng trước, không thể qua trang mới hồi tố tăng chi phí.\n4.10 Đơn vị tối thiểu tài sản, độ chính xác, phương pháp làm tròn từng lệnh và xử lý số dư lẻ phải xác định trước khi phát hành và duy trì nhất quán. Làm tròn trên trang để dễ đọc không được thay đổi chi tiết sổ sách; độ chính xác trong ví dụ tính toán không phải độ chính xác thanh toán đã phê duyệt. Phí giao dịch, chênh lệch giá và số dư lẻ không được ẩn bằng cách hiển thị gộp.\n\nĐiều 5: Dịch vụ hệ thống\n\n5.1 Mất mạng hoặc hết thời gian yêu cầu: người dùng truy vấn lệnh gốc trước, nền tảng trả về trạng thái thực tế đã chấp nhận, từ chối rõ ràng hoặc vẫn chờ xác nhận. Khi kết quả gốc chưa rõ, không được khuyến khích thanh toán trùng; chỉ khi xác nhận sau là chưa chấp nhận, mới xác nhận lại yêu cầu mới theo quy tắc hiệu lực hiện tại.\n5.2 Tín hiệu hoặc báo giá hết hạn: từ chối yêu cầu cũ, hiển thị lý do và lấy lại nội dung. Không được thay thế im lặng hướng mới, số tiền mới hoặc phí mới, cũng không coi hết hạn tự động là reset vi phạm AI. Nếu yêu cầu cũ đã được chấp nhận, vẫn thực hiện theo ảnh chụp đó.\n5.3 Kết quả hoặc giá bất thường: tạm dừng xác định, định giá hoặc phân bổ bị ảnh hưởng, cung cấp trạng thái, phạm vi ảnh hưởng và kênh truy vấn. Thiếu kết quả không thể ghi lỗ thất bại, định giá bất thường không thể dùng để mở rộng cơ số lỗ. Thay nguồn dự phòng phải tuân thứ tự nguồn và quy tắc bất thường đã công bố trước.\n5.4 Chênh lệch sổ sách hoặc trạng thái giao dịch bên ngoài không rõ: kiểm tra hồ sơ gốc và biên nhận bên ngoài trước, không gửi lặp hành động không thể đảo ngược. Sau xác nhận thất bại, giải đóng băng hoặc thử lại theo quy tắc tương ứng; không rõ không đồng nghĩa đã hoàn tiền. Thao tác quỹ người dùng đã hoàn thành và bước mua coin, vào pool chưa hoàn thành phải hiển thị riêng.\n5.5 Thiếu quỹ: dừng nghiệp vụ mới liên quan có thể mở rộng thiếu hụt, giữ nghĩa vụ đã hình thành, thông báo trạng thái chờ xử lý và xử lý theo phương án đã phê duyệt. Không được giả mạo đã ghi có, đổi số dư khả dụng người dùng thành âm hoặc lấp chênh lệch bằng phí bổ sung chưa thông báo.\n5.6 Hạn chế rủi ro: nền tảng có thể thực hiện xác minh hoặc hạn chế cần thiết theo quy tắc đã phê duyệt chính thức và tiết lộ phù hợp, nhưng phải phân biệt hạn chế lệnh mới, trì hoãn thanh toán và hủy tư cách. Hạn chế không được tự động viết lại thắng thua lịch sử hoặc điều kiện kinh tế đã thỏa mãn; áp dụng ngoại lệ cần có sự thật và căn cứ, đồng thời cung cấp kênh xem xét lại khả dụng.\n5.7 Khi bảo trì, ngừng dịch vụ hoặc đóng sản phẩm cụ thể, lệnh lịch sử, bồi thường, tranh chấp và hồ sơ có thể đối chiếu vẫn phải có phương án xử lý. Người dùng không thể thêm giao dịch mới không có nghĩa số dư hiện có, bồi thường phải trả hoặc quyền khiếu nại biến mất. Tắt công tắc nghiệp vụ mới không được đồng thời đóng toàn bộ truy vấn lịch sử và quy trình thực hiện.\n\nĐiều 6: Điều khoản miễn trừ trách nhiệm\n\nCác trường hợp sau gây thua lỗ, dịch vụ không chịu trách nhiệm bồi thường\n6.1 Người dùng không tuân thủ chiến lược: mọi hành vi lệch khỏi quy định quản lý vị thế tiêu chuẩn của nền tảng này\n6.2 Điều kiện thị trường cực đoan: thua lỗ do sàn giao dịch tê liệt, cạn kiệt thanh khoản, thao túng thị trường\n6.3 Rủi ro hệ thống và vận hành: thua lỗ do thiết bị người dùng hỏng, sai sót thao tác, tài khoản bị đánh cắp\n6.4 Rủi ro chính sách và tuân thủ: giao dịch bị gián đoạn hoặc cấm do thay đổi luật, quy định hoặc lệnh giám sát\n6.5 Rủi ro token nội tại: vốn hóa JOULE giảm mạnh hoặc sụp đổ, ảnh hưởng chức năng ký quỹ và tiền tệ thanh toán\n6.6 Gian lận và hành vi ác ý: người dùng liên quan gian lận, rửa tiền, thao túng thị trường hoặc hoạt động bất hợp pháp khác\n6.7 Bất khả kháng: sự cố hệ thống nền tảng này do bất khả kháng\n\nĐiều 7: Công bố rủi ro\n\nNgười dùng xác nhận đã hiểu đầy đủ và chấp nhận các rủi ro sau:\n7.1 Không bảo vốn, không bảo lợi: kế hoạch này chỉ bồi thường một phần thua lỗ, tuyệt đối không đảm bảo an toàn vốn gốc hoặc lợi nhuận\n7.2 Rủi ro phụ thuộc chiến lược: hiệu quả bảo vệ hoàn toàn phụ thuộc tuân thủ nghiêm ngặt chiến lược\n7.3 Rủi ro thanh khoản và khóa: quỹ bồi thường vào tài khoản quản lý tài sản có thể có rủi ro đầu tư và thời gian khóa, ảnh hưởng thanh khoản quỹ\n7.4 Rủi ro bên thứ ba: sàn giao dịch phụ thuộc có rủi ro vận hành, bảo mật và biến động giá trị\n7.5 Rủi ro không chắc chắn về giám sát: nền tảng này đối mặt không chắc chắn giám sát toàn cầu và rủi ro bị dừng\n7.6 Rủi ro an ninh kỹ thuật: bao gồm rủi ro mất tài sản do lỗ hổng hợp đồng thông minh, tấn công hacker, v.v.\n\nĐiều 8: Thay đổi, chấm dứt và tranh chấp thỏa thuận\n\n8.1 Thay đổi thỏa thuận: nền tảng này bảo lưu quyền sửa đổi thỏa thuận này theo pháp luật hoặc nhu cầu vận hành, thay đổi quan trọng sẽ thông báo qua công bố nền tảng\n8.2 Chấm dứt thỏa thuận: người dùng có thể tắt công tắc bảo vệ bất cứ lúc nào để chấm dứt dịch vụ; nếu người dùng vi phạm thỏa thuận, nền tảng có thể chấm dứt đơn phương; vì lý do pháp luật hoặc chính sách, kế hoạch này có thể chấm dứt\n8.3 Giải quyết tranh chấp: tranh chấp phát sinh từ thỏa thuận này nên giải quyết qua thương lượng thiện chí; nếu thương lượng không thành, sẽ nộp lên cơ quan trọng tài hoặc tòa án được chỉ định\n\n【Xác nhận cuối cùng】Bạn hiểu và đồng ý rằng 「Bật công tắc bảo hiểm」 là cách duy nhất và cuối cùng để xác nhận bạn chịu ràng buộc bởi toàn bộ nội dung thỏa thuận này, vui lòng quyết định dựa trên phán đoán độc lập.",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "Kết nối",
    inputPlaceholder: "Nhập địa chỉ",
    bind: "Liên kết",
    binding: "Đang liên kết",
    tip: "Mẹo: Nếu kết nối ví thất bại, bạn có thể thử nhập thủ công địa chỉ ví để liên kết"
  },
  loginModal: {
    title: "Đăng nhập PANTA MARKET",
    connectWallet: "Kết nối",
    connecting: "Đang kết nối...",
    alreadyConnected: "Đã kết nối",
    tip: "Mẹo: Nếu kết nối ví thất bại, bạn có thể thử nhập thủ công địa chỉ ví để liên kết",
    inputLabel: "Nhập địa chỉ ví",
    inputPlaceholder: "0x234d456f6798...",
    bind: "Liên kết",
    binding: "Đang liên kết",
    bindSuccess: "Liên kết thành công",
    bindSuccessHint: "Liên kết thành công, vui lòng đăng nhập lại",
    bindFailed: "Liên kết thất bại",
    noAuthCode: "Thiếu mã ủy quyền",
    invalidAddress: "Định dạng địa chỉ ví không hợp lệ",
    confirmTitle: "Xác nhận liên kết",
    confirmWarning: "Vui lòng xác nhận cẩn thận rằng địa chỉ sau đây là địa chỉ ví của bạn. Không thể thay đổi sau khi liên kết",
    addressLabel: "Địa chỉ ví",
    cancel: "Hủy",
    confirm: "Xác nhận liên kết",
    loginSuccess: "Đăng nhập thành công",
    openWalletApp: "Mở {wallet}",
    openWalletConnect: "Mở {wallet} để kết nối",
    openWalletSign: "Mở {wallet} để ký",
    returnToBrowser: "Quay lại đây khi hoàn tất",
    loginStepLabel: "Bước {step}/2",
    stepConnectTitle: "Kết nối ví",
    stepConnectHint: "Phê duyệt kết nối trong ví, rồi quay lại đây",
    stepConnectHintWithOpen: "Chạm bên dưới để mở ví, phê duyệt kết nối rồi quay lại",
    stepSignTitle: "Đăng nhập",
    stepSignHint: "Ký thông điệp đăng nhập trong ví (không chuyển tài sản), rồi quay lại đây",
    stepSignHintWithOpen: "Thêm một bước: chạm bên dưới để mở ví và ký thông điệp đăng nhập",
    waitingWalletHintShort: "Nếu chưa mở, chạm bên dưới để mở ví",
    retryLogin: "Thử đăng nhập lại",
    networkRequired: "Chuyển mạng",
    networkRequiredHint: "Chuyển sang {chain}, quay lại đây và thử lại",
    switchingNetwork: "Xác nhận chuyển mạng",
    switchingNetworkHint: "Phê duyệt chuyển sang {chain} trong ví",
    signatureRequired: "Ký để đăng nhập",
    signatureHint: "Ký trong ví — thao tác này không chuyển tiền",
    verifyingLogin: "Đang xác minh",
    verifyingHint: "Vui lòng chờ",
    connectFailed: "Kết nối chưa hoàn tất, vui lòng thử lại",

    waitingWalletReturn: "Hoàn tất ủy quyền trong ví rồi quay lại trang này",
    waitingWalletHint: "Xác nhận trong ví, sau đó sẽ tự động quay lại"
  },
  walletProfile: {
    title: "Hồ sơ",
    address: "Địa chỉ",
    accountName: "Tên tài khoản",
    inviteCode: "Mã mời",
    deactivateAccount: "Hủy kích hoạt tài khoản",
    logout: "Đăng xuất",
    switchAccount: "Chuyển tài khoản",
    confirmLogout: "Bạn có chắc chắn muốn đăng xuất?",
    loggingOut: "Đang đăng xuất...",
    confirmSwitch: "Bạn có chắc chắn muốn chuyển tài khoản? Tài khoản hiện tại sẽ đăng xuất",
    developing: "Đang phát triển",
    addressCopied: "Đã sao chép địa chỉ",
    inviteCodeCopied: "Đã sao chép mã mời"
  },
  aiPrediction: {
    stakeAutofill: "Hỗ trợ AI",
    stakeAutofillWarning: "Chỉ hỗ trợ; số tiền gợi ý có thể sai, hãy kiểm tra trước khi đặt lệnh. Tự điền tạm dừng khi độ trễ > 800ms hoặc kiểm tra kết nối thất bại/hết hạn, và tiếp tục khi phục hồi. Không ảnh hưởng đặt lệnh thủ công.",
    stakeAutofillUnavailable: "Kết nối không ổn định hoặc độ trễ trên 800ms. Chưa thể bật.",
    stakeAutofillPaused: "Tự điền tạm dừng: kết nối không ổn định. Vui lòng nhập số tiền thủ công.",
    insuranceSyncing: "Đang đồng bộ bước bảo hiểm…",
    predictionBuffer: 'Đang chuẩn bị dự đoán tiếp theo',
    scheduleResultPending: 'Chưa có kết quả, đang thử lại',
    title: "Dự Đoán AI",
    bookingTitle: "Đặt lịch phiên AI",
    bookingExpand: "Mở rộng",
    bookingCollapse: "Thu gọn",
    bookingNextSystem: "Phiên hệ thống tiếp · SGT",
    bookingNextMine: "Lịch đặt tiếp theo của tôi",
    bookingNone: "Chưa có",
    bookingStartingSoon: "Phiên đã đặt sắp bắt đầu",
    bookingToday: "Hôm nay",
    bookingTomorrow: "Ngày mai",
    bookingTimezone: "SGT",
    bookingQuota: "Còn {remaining}/{dailyLimit} phiên",
    bookingSeats: "{occupied}/{capacity} chỗ",
    bookingEmpty: "Không có phiên khả dụng",
    bookingWaiting: "Sẽ tự vào khi thao tác hiện tại kết thúc",
    bookingEnded: "Đã kết thúc",
    bookingJoin: "Tham gia phiên",
    bookingReserve: "Đặt chỗ",
    bookingJoined: "Đã vào",
    bookingReserved: "Đã đặt",
    bookingFull: "Hết chỗ",
    bookingConfirm: "Xác nhận đặt chỗ",
    bookingWarning: "Đặt thành công sẽ trừ 1 lượt trong ngày; không tham gia vẫn tính.",
    bookingQuotaExhausted: "Đã hết lượt tham gia trong ngày",
    bookingUnavailable: "Hiện không thể đặt chỗ",
    bookingFailed: "Đặt chỗ thất bại. Làm mới và thử lại.",
    aiPool: "Quỹ BH AI",
    countdown: "Đếm Ngược",
    expectedProfit: "Lợi Nhuận Dự Kiến",
    active: "Hoạt Động",
    aiAnalysis: "Phân Tích Xác Suất Tăng/Giảm Thông Minh AI",
    updateTime: "Thời Gian Cập Nhật",
    probabilityUp: "Xác Suất Tăng",
    probabilityDown: "Xác Suất Giảm",
    startPrediction: "Bắt Đầu Dự Đoán",
    predicting: "Đang dự đoán...",
    stayOnPageHint: "Vui lòng không rời trang này, nếu không kết quả dự đoán có thể bị mất.",
    userInfo: "Thông Tin Người Dùng",
    predictCount: "Số Lần Dự Đoán",
    freeCount: "Dự Đoán Miễn Phí",
    openTime: "Mở lúc: {time1}",
    up: "Tăng",
    down: "Giảm",
    notConnected: "Chưa Kết Nối",
    count: "Số Lần",
    learnMore: "Tìm Hiểu Thêm",
    calculating: "Đang tính...",
    settled: "Đã Thanh Toán",
    loginFirst: "Vui lòng đăng nhập trước",
    sessionSyncing: "Đang đồng bộ",
    actions: {
      rise: "Long",
      fall: "Short"
    },
    holdings: {
      current: "Vị Thế",
      history: "Lịch Sử",
      empty: "Không có vị thế",
      historyEmpty: "Không có lịch sử",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "Mua Đặc Quyền",
      description: "Mua 30 Dự Đoán AI",
      upgradeAmount: "Số Tiền Nâng Cấp",
      balance: "Số Dư Khả Dụng",
      cancel: "Cancel",
      confirm: "Xác Nhận",
      purchasing: "Đang mua...",
      purchaseSuccess: "Mua thành công",
      purchaseFailed: "Mua thất bại",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "Dự Đoán AI Thất Bại",
      description: "Số lần dự đoán AI của bạn là 0. Bạn không thể sử dụng dự đoán AI lúc này. Vui lòng mua để tiếp tục.",
      cancel: "Hủy",
      confirm: "Mua Dự Đoán AI"
    },
    toasts: {
      predictionFailed: "Dự đoán thất bại",
      predictionSuccess: "Dự đoán hoàn tất",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "Đang phân tích...",
    insurance: "Bảo hiểm",
    insuranceOn: "Đã hiệu lực",
    insuranceOff: "Chưa hiệu lực",
    aiLabel: "AI",
    lookLong: "Tăng",
    lookShort: "Giảm",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "Theo vòng này",
    scheduleBinding: "Đang liên kết tín hiệu...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "Giá mở",
    settledAt: "Thanh toán lúc",
    ordinaryInsuranceTitle: "Đơn này là bảo hiểm thường",
    ordinaryInsuranceBody: "Đơn này là bảo hiểm thường, không thuộc chi trả vòng AI. Sau khi xác nhận sẽ gửi theo phí xem trước.",
    sessionConflict: "Đang có vòng bảo hiểm AI. Hãy khôi phục hoặc kết thúc trước khi đặt bảo hiểm thường.",
    conversionTitle: "Chuyển sang bảo hiểm thường?",
    conversionDesc: "Lệnh này sẽ chuyển sang bảo hiểm thường và kết thúc vòng bảo hiểm AI. Chuỗi lỗ AI trước đó sẽ không được bồi. Phí bảo hiểm thường {premium} JOULE.",
    conversionConfirm: "Xác nhận chuyển và đặt lệnh",
    stakeFromStrategy: "Khối lượng do chiến lược chỉ định",
    stakeTier: "Bậc {tier}",
    stakeStep: "Bước {step}",
    selfQuotaRemaining: "Lượt tự dự đoán còn: {remaining}/{limit}",
    followRoundProgress: "Theo AI · Vòng {current}/{total}",
    followRoundsCompleted: "Theo AI hoàn tất · {current}/{total}",
    selfQuotaLoadingShort: "Đang tải lượt…",
    selfQuotaLoginHint: "Đăng nhập để xem lượt",
    selfQuotaLoading: "Đang tải lượt, thử lại sau",
    selfQuotaExhausted: "Hết lượt tự dự đoán miễn phí hôm nay; dự đoán trả phí chưa mở"
  },
  positionModal: {
    title: "Dự đoán giá",
    insurance: "Bảo hiểm",
    long: "Long",
    short: "Short",
    balance: "Số dư",
    loading: "Đang tải...",
    confirm: "Xác nhận",
    processing: "Đang xử lý lệnh...",
    success: "Đặt lệnh thành công!",
    insuranceOn: "Đã bật bảo hiểm",
    insuranceOff: "Đã tắt bảo hiểm",
    operationFailed: "Thao tác thất bại",
    balanceFetchFailed: "Không thể lấy số dư",
    minAmount: "Số tiền tối thiểu là 0.1 TAKER",
    insufficientBalance: "Số dư không đủ, số dư hiện tại: {balance} TAKER",
    createFailed: "Không thể tạo vị thế",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  assets: {
    insuranceFrozen: "Hạn mức đóng băng bảo hiểm (JOULE)",
    available: "Có sẵn",
    deposit: "Nạp tiền",
    withdraw: "Rút tiền",
    myAccountRecords: "Hồ sơ tài khoản của tôi",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "Đóng băng cược",
      WIN_PAYOUT: "Lợi nhuận giao dịch",
      LOSS_SETTLEMENT: "Lỗ giao dịch",
      REFUND: "Hoàn tiền",
      INSURANCE_PREMIUM: "Chi phí bảo hiểm",
      INSURANCE_PAYOUT: "Chi trả bảo hiểm",
      INSURANCE_TRANSFER_IN: "Chuyển vào bảo hiểm",
      INSURANCE_TRANSFER_OUT: "Chuyển ra bảo hiểm",
      NETWORK_DIFFERENTIAL: "Thưởng chênh lệch giao dịch",
      NETWORK_PEER: "Thưởng đồng cấp giao dịch",
      NETWORK_UNLOCK: "Mở khóa lợi nhuận",
      EVENT_INSURANCE_PAYOUT: "Chi trả nút sức mạnh",
      EVENT_INSURANCE_PEER: "Thưởng đồng cấp sức mạnh",
      TRANSFER_IN: "Chuyển vào",
      TRANSFER_OUT: "Chuyển ra",
      PREMIUM_LOCK: "Khóa phí bảo hiểm",
      PREMIUM_SETTLE: "Chi phí bảo hiểm",
      PREMIUM_REFUND: "Hoàn phí bảo hiểm",
      WEALTH_SUBSCRIPTION: "Đăng ký quỹ",
      SUBSCRIPTION_LOCK: "Khóa staking",
      WEALTH_DAILY_REWARD: "Lãi ngày quỹ",
      WEALTH_TEAM_REWARD: "Thưởng đội nhóm quỹ",
      MATURITY_RELEASE: "Hoàn gốc đáo hạn",
      WEALTH_UNLOCK: "Mở khóa lợi nhuận",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "Lãi/lỗ giao dịch",
      PREMIUM: "Phí bảo hiểm",
      INSURANCE_PAYOUT: "Chi trả bảo hiểm",
      TEAM_REWARD: "Thưởng đội nhóm",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "Lãi ngày quỹ",
      UNLOCK: "Mở khóa",
      PRINCIPAL: "Đăng ký/hoàn gốc",
      TRANSFER: "Chuyển nội bộ"
    },
    amountPendingReview: "Số tiền chờ đối chiếu",
    creditedSplit: "Khả dụng {available} · Đóng băng {frozen}",
    creditedSplitPending: "Tách khoản chờ đối chiếu",
    afterBalance: "Sau biến động: khả dụng {available} · đóng băng {frozen}",
    unlockHint: "Đóng băng → khả dụng; không phải lợi nhuận mới",
    transferFromInsurance: "Tài khoản bảo hiểm",
    transferFromMain: "Tài khoản chính",
    all: "Tất cả",
    transfer: "Chuyển khoản",
    insuranceDeduction: "Khấu trừ bảo hiểm",
    insurancePayout: "Thanh toán bảo hiểm",
    noRecords: "Không có hồ sơ",

    actions: {
      deposit: "Nạp tiền",
      withdraw: "Rút tiền",
      exchange: "Trao đổi",
      transfer: "Chuyển khoản"
    },
    loginPrompt: {
      text: "Vui lòng kết nối ví trước",
      button: "Kết nối"
    },
    toasts: {
      connectFailed: "Kết nối thất bại, vui lòng thử lại"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "Copy",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "Tài khoản copy (JOULE)",
    copyTotalPnl: "PnL copy",
    transferSheet: {
      title: "Chuyển",
      pairCopy: "Giao dịch / Copy",
      pairInsurance: "Giao dịch / Bảo hiểm",
      tradingAccount: "Tài khoản giao dịch",
      copyAccount: "Tài khoản copy",
      insuranceAccount: "Tài khoản bảo hiểm",
      jouleHint: "Chỉ hỗ trợ chuyển JOULE",
      submit: "Gửi",
      transferring: "Đang chuyển...",
      success: "Chuyển thành công",
      failed: "Chuyển thất bại, vui lòng thử lại",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "Giá trị này là tổng gốc stake và lợi nhuận ước tính.",
    stakedPrincipalLabel: "Gốc stake",
    stakedExpectedYieldLabel: "Lợi nhuận ước tính",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "Thu nhập nhóm quỹ chờ trả (PANTA)",
    fundTeamPaidPanta: "Thu nhập nhóm quỹ đã trả (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "Giá trị airdrop tích lũy: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  appeal: {
    title: "Hỗ trợ kiểm duyệt tài sản",
    records: "Hồ sơ gửi",
    recordsTitle: "Hồ sơ gửi",
    noRecords: "Không có hồ sơ gửi",
    submitTime: "Thời gian gửi",
    statusPending: "Đang xử lý",
    statusApproved: "Đã phê duyệt",
    statusRejected: "Từ chối",
    failedReason: "Lý do từ chối",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "Đang tải...",
    walletAddress: "Địa chỉ liên kết với PANTA MARKET",
    address: "Địa chỉ",
    walletAddressPlaceholder: "Nhập địa chỉ đăng nhập PANTA MARKET",
    autoFill: "Tự động điền",
    depositAmount: "Số tiền nạp",
    depositAmountPlaceholder: "Nhập số tiền nạp",
    tokenType: "Loại token",
    selectToken: "Chọn token",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "Thời gian chuyển",
    selectTime: "Chọn thời gian chuyển",
    timeRangeHint: "Dữ liệu liên quan được tạo ra từ ngày 5 tháng 3 năm 2026 lúc 00:00 đến ngày 11 tháng 3 lúc 10:00 (SGT).",
    txHash: "HASH / TXID",
    txHashPlaceholder: "Nhập hash giao dịch",
    txHashHint: "Có thể tra cứu trên trình khám phá blockchain",
    uploadImages: "Ảnh chụp màn hình giao dịch",
    uploadHint: "Tùy chọn, tải lên tối đa 9 hình ảnh",
    addImage: "Thêm hình ảnh",
    submit: "Gửi",
    submitting: "Đang gửi...",
    submitSuccess: "Gửi thành công",
    submitFailed: "Gửi thất bại, vui lòng thử lại",
    uploadingImages: "Đang tải lên hình ảnh...",
    uploadImagesFailed: "Tải lên hình ảnh thất bại",
    warningTitle: "Thông báo quan trọng",
    warningText: "Nếu hồ sơ được xác minh thành công, bạn sẽ được thưởng 5% sức mạnh đăng ký. Nếu cung cấp thông tin sai, tài khoản sẽ bị đóng băng."
  },
  withdrawSheet: {
    title: "Rút tiền",
    balance: "Số dư",
    processing: "Đang rút TAKER...",
    success: "Rút TAKER thành công!",
    withdrawing: " đang rút...",
    withdrawSuccess: " Đã gửi chờ duyệt",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "Nạp TAKER",
    depositTo: "Nạp vào",
    spotAccount: "Tài khoản Spot",
    network: "Mạng",
    networkWarning: "Chỉ hỗ trợ nạp tiền qua mạng BSC/BEP20. Tổn thất tài sản do sử dụng mạng khác không thể khôi phục.",
    depositAddress: "Địa chỉ nạp",
    address: "Địa chỉ",
    depositTAKER: "Nạp TAKER",
    recharge: "Nạp tiền",
    rechargeAddress: "Địa chỉ nạp tiền",
    copy: "Sao chép",
    copySuccess: "Sao chép thành công",
    loadingAddress: "Đang lấy địa chỉ nạp tiền...",
    loadAddressFailed: "Không thể lấy địa chỉ nạp tiền",
    clickToRetry: "Nhấp để thử lại",
    saveAndShare: "Lưu và chia sẻ địa chỉ",
    generating: "Đang tạo...",
    generateSuccess: "Tạo thành công",
    generateFailed: "Tạo thất bại",
    more: "Thêm",
    save: "Lưu",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "Hình ảnh đã lưu",
    download: "Tải xuống",
    pleaseGenerate: "Vui lòng tạo hình ảnh trước",
    downloadSuccess: "Tải xuống thành công",
    saveSuccess: "Lưu thành công",
    saveFailed: "Lưu thất bại",
    needPermission: "Cần quyền để lưu hình ảnh vào album",
    pleaseUseDapp: "Vui lòng sử dụng ví để mở hoạt động dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "Đăng nhập tài khoản",
    inviteBanner: "Mời bạn bè và nhận hoa hồng đội",
    inviteCode: "Mã mời",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "Giới thiệu của tôi",
    currentLevel: "Cấp độ hiện tại: {level}",
    nextLevel: "Cấp độ tiếp theo",
    totalMembers: "Giới thiệu trực tiếp",
    validMembers: "Thành viên hợp lệ",
    teamLevel: "Cấp độ đội: {level}",
    tradeTeam: "Đội giao dịch",
    financeTeam: "Đội tài chính",
    teamMembers: "Thành viên đội",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "Trực tiếp của {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "Tổng lợi nhuận",
    totalFlow: "Tổng dòng tiền",
    totalInvites: "Tổng số lời mời",
    validMembers: "Tổng thành viên hợp lệ"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "Chat mới",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "Xin chào, tôi là trợ lý AI",
    hint: "Hỏi phân tích thị trường, chỗ xem quy tắc BH sự kiện/AI, đội & mời, hoặc rủi ro.",
    placeholder: "Hỏi gì đó...",
    send: "Gửi",
    thinking: "Đang phân tích...",
    disclaimer: "Chỉ tham khảo, không phải tư vấn đầu tư.",
    bullish: "Tăng",
    bearish: "Giảm",
    aiAnalysis: "Tóm tắt AI",
    strategy: "Chiến lược",
    reasoning: "Lập luận",
    targetPrice: "Mục tiêu {price}",
    stopLoss: "Cắt lỗ {price}",
    takeProfit: "Chốt lời {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "Trung lập",
    analysisDone: "Đã xong phân tích {symbol} ({timeframe}). Xem thẻ bên dưới.",
    analysisBtc: "Phân tích ngắn hạn BTC.",
    analysisEth: "Phân tích dao động ETH.",
    analysisRisk: "Diễn giải rủi ro thị trường.",
    suggestions: {
      btc1m: "Phân tích BTCUSDT 1m ngắn hạn",
      ethTrend: "ETH nên đuổi hay đứng ngoài?",
      marketRisk: "Khẩu vị rủi ro thị trường hiện tại?",
      eventRules: "Xem nhanh quy tắc BH hợp đồng sự kiện ở đâu?",
      aiRules: "Hiểu quy tắc/bậc AI prediction thế nào?",
      teamWhere: "Xem chi tiết đội ở đâu?",
      inviteWhere: "Link mời & gắn cấp trên ở đâu?"
    },
    guides: {
      eventRules: "Quy tắc BH sự kiện: vào trang Event Contract, mở mục quy tắc cạnh công tắc BH. Tab Tóm tắt cho phí/hạn mức/quyền bồi; tab Thỏa thuận đầy đủ cho điều khoản.",
      aiRules: "AI Prediction: tab giữa → AI Prediction. Xem countdown vòng sau, bậc/bước BH, số lần tự dự đoán. Quy tắc nằm trong sheet BH (tóm tắt AI + thỏa thuận). Lệnh phải khớp số tiền bậc và hướng.",
      teamWhere: "Chi tiết đội: sidebar hoặc Tôi → Đội của tôi. Đổi LN giao dịch/tài chính, bấm Chi tiết đội để xem giới thiệu thẳng, volume, cấp, thành viên.",
      inviteWhere: "Mời & gắn: sidebar/Tôi → Mời bạn bè để copy link (?ref=). Chưa gắn cấp trên sẽ hiện popup sau đăng nhập. Không có tham số mời thì ô nhập điền sẵn địa chỉ mặc định hệ thống."
    },
    generic: {
      a: "Đã nhận. Hỏi thị trường, vị trí quy tắc sự kiện/AI, đội & mời, hoặc bấm gợi ý bên dưới.",
      b: "OK. Thẻ triển vọng và hướng dẫn tính năng.",
      c: "Thử gợi ý quy tắc sự kiện, quy tắc AI, chi tiết đội, link mời."
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "Giao dịch gần đây",
    tabLp: "LP",
    tabPositions: "Vị thế",
    tabRules: "Quy tắc",
    colAddress: "Địa chỉ",
    colTime: "Thời gian",
    colType: "Loại",
    colVolumePrice: "KL/Giá",
    colTurnover: "Giá trị",
    typeBuy: "Mua",
    typeSell: "Bán",
    empty: "Không có dữ liệu",
    share: "Chia sẻ",
    rulesBody: "Thị trường dự đoán sự kiện nhị phân. Sổ lệnh có thể khóa trước thanh toán; sau công bố kết quả sẽ tất toán theo cổ phần nắm giữ. Hãy lưu ý rủi ro.",
    priceJoule: "Giá (JOULE)",
    investJoule: "Đầu tư (JOULE)",
    totalLiquidity: "Thanh khoản",
    dealPrice: "Giá khớp",
    estProfit: "LN ước tính",
    jouleBalance: "Số dư JOULE: {n}",
    positionCount: "Số vị thế: {n}",
    max: "Tối đa",
    confirmOrder: "Xác nhận lệnh",
    ordering: "Đang đặt...",
    enterAmount: "Nhập số tiền",
    invalidPrice: "Giá không hợp lệ",
    amountExceed: "Vượt số dư",
    orderSuccess: "Đặt lệnh thành công",
    poolSize: "Quy mô pool",
    colBalance: "Số dư",
    shares: "{n} đơn vị",
    rulesTitle: "Quy tắc",
    rulesValue: "Chưa có mô tả",
    settleSource: "Nguồn tất toán",
    settleValue: "Chưa có mô tả"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "Token quản trị PANTA",
    todayBurn: "Đốt hôm nay",
    totalBurn: "Tổng đã đốt",
    burned: "Đã đốt",
    initialSupply: "Phát hành ban đầu",
    maxSupply: "Phát hành tối đa",
    finalCirculation: "Lưu thông cuối",
    contractAddress: "Hợp đồng: ",
    copied: "Đã sao chép",
    ecoSection: "PANTA · Hệ sinh thái AI",
    ecoTabs: {
      market: "Phân tích thị trường",
      arbitrage: "Công cụ chênh lệch",
      acquisition: "Thu hút toàn cầu",
      video: "Sáng tạo video"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · Nhóm sáng tạo",
    groupTabs: {
      recommend: "Đề xuất",
      hot: "Thịnh hành",
      ipDrama: "Phim ngắn IP",
      ipCollab: "Đồng sáng tạo IP",
      data: "Dữ liệu"
    },
    filters: {
      all: "Tất cả",
      new: "Mới ra mắt",
      ending: "Sắp kết thúc",
      highScore: "Điểm AI cao"
    },
    project: {
      badge: "Ra mắt trên Planet",
      title: "《Panta AI · Trỗi dậy》 Phim hoạt hình AI ngắn",
      score: "Điểm AI 92",
      tagDrama: "Phim ngắn IP",
      tagRights: "Quyền #0001",
      desc: "Panta AI giúp tôi lật ngược tình thế — phim ngắn hướng dẫn app AI"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4.212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "Sao chép giao dịch",
    pageTitle: "Sao chép giao dịch",
    fallback: "Thao tác thất bại. Vui lòng thử lại sau.",
    pauseRule: "Nếu vẫn đang tạm dừng khi quyết toán tuần này hoàn tất, quan hệ sao chép sẽ tự động hủy vào tuần sau.",
    pauseSuccess: "Tạm dừng thành công",
    resumeSuccess: "Đã tiếp tục",
    endSuccess: "Đã kết thúc",
    followSuccess: "Đã bắt đầu sao chép",
    pendingReviewToast: "Chờ trader duyệt",
    savedSuccess: "Đã lưu",
    registerSuccess: "Đăng ký thành công. Tiền ký quỹ đã đóng băng.",
    cancelRequested: "Đã yêu cầu hủy",
    cancelWithdrawn: "Đã rút yêu cầu hủy",
    kickedSuccess: "Đã loại bỏ",
    approvedSuccess: "Đã duyệt",
    rejectedSuccess: "Đã từ chối",
    filledToForm: "Đã điền vào biểu mẫu theo dõi",
    traderNotFound: {
      search: "Không tìm thấy trader. Kiểm tra địa chỉ ví hoặc họ có thể chưa bật sao chép giao dịch.",
      business: "Trader này hiện không khả dụng"
    },
    tabs: {
      board: "Bảng xếp hạng",
      follows: "Theo dõi của tôi",
      join: "Theo dõi",
      trader: "Dẫn lệnh",
      apps: "Đơn đăng ký",
      fans: "Người theo",
      rules: "Quy tắc",
      settings: "Quy tắc",
      follow: "Theo dõi"
    },
    ui: {
      refresh: "Làm mới",
      search: "Tìm kiếm",
      loginWallet: "Kết nối ví",
      needLoginAction: "Thao tác này cần đăng nhập ví, giống khi đặt lệnh.",
      needLoginTrader: "API trader yêu cầu đăng nhập.",
      loginToView: "Đăng nhập để xem",
      loading: "Đang tải…",
      empty: "Không có",
      readonly: "chỉ đọc",
      yes: "Có",
      no: "Không",
      immediate: "có hiệu lực ngay",
      current: "Hiện tại",
      nextWeek: "Tuần sau",
      pause: "Tạm dừng",
      resume: "Tiếp tục",
      end: "Kết thúc",
      save: "Lưu",
      kick: "Loại bỏ",
      approve: "Duyệt",
      reject: "Từ chối",
      requestCancel: "Yêu cầu hủy",
      withdrawCancel: "Rút yêu cầu hủy",
      confirmFollow: "Xác nhận theo dõi",
      registerWithDeposit: "Đóng băng ký quỹ và đăng ký",
      registerConfirmTitle: "Xác nhận đăng ký",
      registerFreezeConfirm: "Tài khoản giao dịch sẽ đóng băng {amount} JOULE làm ký quỹ.",
      platformSettings: "Cài đặt nền tảng",
      settingsTip: "Chỉ sao chép lệnh dẫn thường có bảo hiểm. Lệnh thường không bảo hiểm và lệnh AI không được sao chép, lệnh COPY tạo ra cũng không dẫn tiếp. Trader dùng API đặt lệnh hiện có và không được truyền orderSource. Người theo thấy lệnh COPY trong danh sách. Số tiền hiển thị 2 chữ thập phân; phần dư bị cắt.",
      deposit: "Tiền ký quỹ",
      depositFreezeWeeks: "Số tuần đóng băng ký quỹ",
      maxFollowers: "Giới hạn người theo",
      shareRateRange: "Khoảng tỷ lệ chia sẻ",
      shareRateDefault: "Tỷ lệ chia sẻ mặc định",
      shareRateNextWeek: "Tỷ lệ chia sẻ áp dụng tuần sau",
      pendingShareHint: "Hiệu lực thứ Hai tới: {rate}",
      pendingMaxFollowersHint: "Hiệu lực thứ Hai tới: {n}",
      depositFrozenShort: "Vẫn đóng băng",
      minFollowStake: "Vốn theo dõi tối thiểu",
      ratioRange: "Khoảng tỷ lệ",
      maxSimultaneousFollows: "Theo dõi đồng thời tối đa",
      defaultReview: "Duyệt mặc định",
      defaultMinBalance: "Ngưỡng số dư mặc định",
      settlementTimezone: "Múi giờ quyết toán",
      leaderboardMeta: "Tối thiểu bảng / kích thước",
      leaderboardMetaValue: "{min} lệnh / {size} dòng",
      weekLeaderboard: "Bảng tỷ lệ thắng tuần này",
      expertLeaderboard: "Bảng xếp hạng trader",
      heroTitle: "Trở thành trader dẫn lệnh",
      heroDesc: "Bắt đầu dẫn lệnh và nhận chia sẻ lợi nhuận",
      heroActiveTitle: "Bạn là trader dẫn lệnh",
      heroActiveDesc: "Trạng thái trader dẫn lệnh của bạn đang hoạt động",
      heroRegister: "Đăng ký",
      heroSettings: "Cài đặt dẫn lệnh",
      myLeading: "Dẫn lệnh của tôi",
      winRateBoard: "Tỷ lệ thắng",
      pnlBoard: "Lợi nhuận",
      searchAddress: "Tìm địa chỉ",
      searchNicknameOrAddress: "Tìm biệt danh hoặc địa chỉ",
      searchQueryTooShort: "Nhập ít nhất 2 ký tự",
      winRateShort: "Tỷ lệ thắng",
      followersLabel: "Người theo:",
      shareRateLabel: "Tỷ lệ chia sẻ:",
      roundPnlLabel: "PnL vòng:",
      settledOrders: "Đã quyết toán {n}",
      activeCount: "Đang diễn ra",
      followStatsShort: "Pool {pool} · Giữ {cash}",
      traderSettings: "Cài đặt dẫn lệnh",
      confirmChanges: "Xác nhận thay đổi",
      confirmCancel: "Xác nhận hủy",
      cancelModalTitle: "Thông báo hủy",
      activeInProgress: "Đang diễn ra",
      leadingFollowerCount: "Người theo lệnh {n}",
      auditApps: "Đơn đăng ký {n}",
      leaderboardNote: "Chỉ tính lệnh thường có bảo hiểm thắng/thua đã quyết toán tuần này, sau số lệnh tối thiểu. Không phải tỷ lệ thắng toàn thời gian hay AI. Không có tên đội và khối lượng theo dõi tích lũy.",
      weekStart: "Bắt đầu tuần (T2): {date}",
      leaderboardEmpty: "Chưa có trader trên bảng. Tìm địa chỉ đầy đủ để theo dõi.",
      winRate: "Thắng {n}%",
      boardSub: "Chia sẻ {share} · Người theo {followers}/{max} · Quyết toán {orders} · PnL tuần {pnl} JOULE",
      searchTrader: "Tìm trader",
      walletPlaceholder: "Địa chỉ ví đầy đủ 0x…",
      address: "Địa chỉ",
      status: "Trạng thái",
      shareRate: "Tỷ lệ chia sẻ",
      review: "Duyệt",
      minBalance: "Ngưỡng số dư",
      followerCount: "Người theo",
      startFollow: "Bắt đầu theo dõi",
      traderWallet: "Địa chỉ trader",
      followMode: "Chế độ theo dõi",
      ratioLabel: "Tỷ lệ (%), khoảng {min} ~ {max}",
      insuranceMode: "Chế độ bảo hiểm",
      takeProfit: "Chốt lời (JOULE, tùy chọn)",
      stopLoss: "Cắt lỗ (JOULE, tùy chọn)",
      takeProfitPh: "Tạm dừng khi PnL ròng tuần đạt mức này",
      stopLossPh: "Tạm dừng khi lỗ ròng tuần đạt mức này",
      followHint: "Bạn có thể theo dõi tối đa {n} trader cùng lúc. Khi đạt giới hạn, theo trader mới sẽ kết thúc quan hệ hiện tại trước — không phải xem trước không ảnh hưởng. Để đổi tham số, hãy kết thúc và theo lại.",
      endConfirm:
        "Xác nhận kết thúc quan hệ copy trade với trader này? Sau khi kết thúc sẽ không còn theo tín hiệu của họ. Lệnh lịch sử và PnL đã tất toán không bị ảnh hưởng.",
      weeklyPoolHint: "Pool là của tuần này, không phải khối lượng theo dõi tích lũy. Quan hệ đã kết thúc và đơn chờ duyệt không có trong danh sách này.",
      networkUnclear: "Kết quả chưa xác nhận. Làm mới và kiểm tra quan hệ hiện tại hoặc hồ sơ trader trước khi thử lại.",
      myFollows: "Theo dõi của tôi",
      noFollows: "Không có quan hệ theo dõi",
      followSub: "{mode}{ratio} · {insurance} · Chia sẻ khóa {share}",
      followStats: "PnL tuần {pnl} · Pool {pool} · Giữ {cash}",
      pauseReason: "Lý do tạm dừng: {reason}",
      registerTrader: "Đăng ký làm trader",
      registerHint: "Đăng ký: nộp {amount} JOULE làm tiền ký quỹ trader dẫn (đóng băng khi hoạt động; hoàn sau duyệt hủy). Một danh tính trader mỗi ví.",
      registerBalanceHint: "Sau khi đóng băng ký quỹ {deposit} JOULE, số dư khả dụng vẫn phải ≥ {remain} JOULE.",
      shareRateInput: "Tỷ lệ chia sẻ (%) khoảng {min} ~ {max}; thay đổi áp dụng chu kỳ sau.",
      maxFollowersInput: "Giới hạn người theo (≤ {max})",
      reviewMode: "Phương thức duyệt",
      minBalanceInput: "Ngưỡng số dư người theo · tùy chọn (JOULE)",
      myTrader: "Hồ sơ trader của tôi",
      depositHeld: "{amount} / đóng băng {held}",
      currentFollowers: "Người theo hiện tại",
      cancelEffective: "Hủy có hiệu lực lúc",
      depositRelease: "Hoàn ký quỹ lúc",
      editParams: "Sửa cài đặt",
      editHint: "Chia sẻ/giới hạn áp dụng tuần sau; duyệt và ngưỡng áp dụng ngay. Khóa quyết toán CN 22:00 đến trước T2 01:00 (SGT). Tin máy chủ; đừng tự sửa lúc T2 00:00.",
      shareRatePercent: "Tỷ lệ chia sẻ (%)",
      minBalanceJoule: "Ngưỡng số dư (JOULE)",
      cancelTip: "Sau hủy bạn vẫn dẫn lệnh tuần này; danh tính kết thúc thứ Hai tuần sau 00:00; ký quỹ đóng băng thêm một tuần rồi hoàn. Có thể rút trước khi có hiệu lực.",
      followers: "Người theo",
      followerSub: "{mode}{ratio} · PnL tuần {pnl} · Giữ {cash}",
      applications: "Đơn chờ duyệt",
      noApplications: "Không có đơn",
      fillForm: "Điền biểu mẫu theo dõi",
      needTraderFirst: "Hãy đăng ký trader trước",
      cancelRequestedAt: "Yêu cầu hủy lúc",
      ratioRangeInvalid: "Tỷ lệ phải từ {min} đến {max}",
      shareRangeInvalid: "Tỷ lệ chia sẻ phải từ {min} đến {max}",
      maxFollowersInvalid: "Giới hạn người theo không được vượt {max}",
      needShareRate: "Nhập tỷ lệ chia sẻ",
      needMaxFollowers: "Nhập giới hạn người theo",
      needRatio: "Nhập tỷ lệ",
      badTakeProfit: "Số tiền chốt lời không hợp lệ",
      badStopLoss: "Số tiền cắt lỗ không hợp lệ",
      badMinBalance: "Ngưỡng số dư không hợp lệ",
      insuranceShortFollow: "Theo",
      insuranceShortOn: "Luôn bật",
      insuranceShortOff: "Luôn tắt",
      symbolSettings: "Cài đặt mã sao chép",
      symbolPickHint: "mặc định tắt hết; bật thủ công, sửa bất cứ lúc nào",
      followSymbolHint: "Chọn từ mã trader này cho phép. Bật ít nhất một.",
      followSymbolWait: "Tìm trader trước, rồi chọn mã để theo dõi.",
      symbolNeedOne: "Bật ít nhất một mã",
      symbolNotAllowed: "Một mã đã chọn không được trader này cho phép",
      effectiveSymbols: "Hiệu lực",
      editSymbols: "Sửa mã",
      allowedSymbols: "Mã mở",
      weekPnlLabel: "PnL tuần:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "Tiền mã hóa",
      categoryCommodity: "Hàng hóa",
      categoryEquity: "Cổ phiếu",
      symbolListCol: "Danh sách",
      symbolLeadCol: "Dẫn",
      symbolFollowCol: "Theo",
      symbolTags: "Mở",
      leadingSymbols: "Mã dẫn lệnh",
      detail: "Chi tiết",
      enabled: "Bật",
      disabled: "Tắt",
      held: "Đang giữ",
      notHeld: "Không giữ",
      weekSettledOrders: "Quyết toán tuần",
      historicalNetPnl: "PnL tích lũy",
      copyTotalPnl: "Tổng PnL copy",
      historicalSharePayout: "Chi trả chia sẻ",
      allOrders: "Tất cả",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "Đang mở",
      settledOrdersTab: "Đã quyết toán",
      colInterval: "Thời lượng",
      colOrderTime: "Thời gian lệnh",
      colSelfPnl: "PnL riêng (gồm phí bảo hiểm)",
      colEstShare: "Chia sẻ ước tính (JOULE)",
      traderOrdersTitle: "Lệnh dẫn {symbol}",
      followOrdersTitle: "Lệnh sao chép {symbol}",
      selfPnl: "PnL riêng",
      estimatedShare: "Chia sẻ ước tính",
      inProgress: "Đang diễn ra",
      followAssets: "PnL theo tài sản",
      byAsset: "Theo tài sản",
      followHistory: "Đã kết thúc",
      followStartTime: "Bắt đầu: ",
      followEndTime: "Kết thúc: ",
      myPendingApps: "Chờ duyệt",
      cashHeldHint: "Chia sẻ ước tính giữ tuần này {cash} JOULE",
      cashHeldFrozen: "Khấu trừ chia sẻ ước tính vòng này: {cash} (JOULE, đóng băng)",
      followedTrader: "Trader",
      followInfo: "Thông tin theo dõi",
      totalPnlJoule: "Tổng PnL (JOULE)",
      colTrader: "Trader",
      colPrincipal: "Vốn",
      colPnlShare: "PnL (gồm phí BH) / chia sẻ (JOULE)",
      traderInfo: "Hồ sơ trader",
      traderNotFound: "Không tìm thấy trader",
      followSettingsRelationHint: "Chế độ theo, bảo hiểm và TP/SL áp dụng cho toàn bộ quan hệ với mọi cặp đã chọn. Bạn có thể sửa bất cứ lúc nào trong Cài đặt theo.",
      followSettingsPrepareHint: "Sau khi xác nhận, cùng cấu hình sẽ áp dụng cho mọi cặp bạn chọn.",
      followOptions: "Tùy chọn theo dõi",
      noFollowOptions: "Không có tùy chọn theo dõi~",
      symbolFollowing: "Đang theo",
      symbolPaused: "Tạm dừng",
      symbolIdle: "Chưa theo",
      cancelFollowSymbol: "Bỏ theo",
      cancelSymbolConfirm: "Bỏ theo {symbol}?",
      cancelLastSymbolConfirm: "Đây là mã cuối cùng. Bỏ theo sẽ kết thúc toàn bộ quan hệ. Tiếp tục?",
      followNow: "Theo ngay",
      followAll: "Theo",
      unfollowAll: "Bỏ theo dõi",
      unfollowAllConfirm: "Bỏ theo tất cả mã của trader này? Sẽ kết thúc toàn bộ quan hệ sao chép.",
      followSettings: "Cài đặt theo dõi",
      goFollowSettings: "Mở ›",
      copyAccountBalance: "Tài khoản copy: {amount} JOULE",
      orderFollowerCount: "Số người theo lệnh này",
      copyingStatus: "Đang copy",
      roleStatusLeading: "Đang dẫn lệnh",
      roleStatusFollowing: "Đang theo lệnh",
      roleStatusPaused: "Theo lệnh đã tạm dừng",
      copyOrderTag: "Copy",
      copyOpenPositions: "Vị thế copy đang mở",
      copyInsuredOrdinary: "Đã mua bảo hiểm thường",
      copyUninsured: "Chưa bảo hiểm",
      addSymbolHint: "Mã này sẽ được thêm vào theo dõi hiện tại của bạn.",
      myRelationStatus: "Theo dõi của tôi",
      latestSettlements: "Quyết toán mới nhất",
      resumeRelationFirst: "Quan hệ đang tạm dừng toàn bộ. Tiếp tục trong Theo dõi của tôi trước khi thao tác theo mã.",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "Loại",
      colPnlJoule: "PnL (JOULE)",
      tpSl: "Chốt lời / cắt lỗ",
      takeProfitPhFull: "Tạm dừng sau lợi nhuận ròng tuần — tùy chọn (JOULE)",
      stopLossPhFull: "Tạm dừng sau lỗ ròng tuần — tùy chọn (JOULE)",
      confirmModify: "Xác nhận",
      clearSearch: "Về bảng xếp hạng",
      searchResultHint: "Kết quả tìm kiếm (chạm để mở hồ sơ trader)",
      searchEmpty: "Không tìm thấy trader",
      noMoreSettlements: "Không còn nữa"
    },
    errors: {
      AUTH_REQUIRED: "Vui lòng kết nối ví trước",
      AUTH_UNAVAILABLE: "Dịch vụ đăng nhập tạm thời không khả dụng. Vui lòng thử lại sau.",
      POSTGRES_REQUIRED: "Dịch vụ tạm thời không khả dụng. Vui lòng thử lại sau.",
      USER_NOT_FOUND: "Không tìm thấy người dùng. Đăng nhập lại và thử lại.",
      INVALID_WALLET: "Nhập địa chỉ ví đầy đủ",
      INVALID_QUERY: "Từ khóa không hợp lệ; nhập ít nhất 2 ký tự",
      INVALID_AMOUNT: "Định dạng số tiền không hợp lệ",
      INVALID_PARAM: "Tham số không hợp lệ. Kiểm tra và thử lại.",
      INVALID_FOLLOW: "Không thể sao chép giao dịch của chính mình",
      TRADER_EXISTS: "Ví này đã là trader. Không cần đăng ký lại.",
      TRADER_FULL: "Trader này đã đạt giới hạn người theo",
      TRADER_CANCELLED: "Tài khoản trader này đã bị hủy",
      TRADER_REGISTER_FAILED: "Đăng ký trader thất bại. Vui lòng thử lại sau.",
      TRADER_SETTINGS_FAILED: "Lưu cài đặt trader thất bại. Vui lòng thử lại sau.",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "Số dư khả dụng không đủ để đóng băng ký quỹ",
      BALANCE_TOO_LOW: "Số dư tài khoản copy dưới ngưỡng trader này. Hãy chuyển từ tài khoản giao dịch trước",
      COPY_BALANCE_ZERO: "Số dư tài khoản copy là 0. Hãy chuyển từ tài khoản giao dịch trước",
      INSUFFICIENT_FUNDS: "Số dư tài khoản giao dịch không đủ để chuyển vào tài khoản copy",
      COPY_TRADE_BALANCE_INSUFFICIENT: "Số dư khả dụng tài khoản copy không đủ (gốc/phân chia đóng băng không rút được)",
      ACCOUNT_NOT_FOUND: "Lỗi tài khoản. Vui lòng thử lại sau.",
      ACCOUNT_CONFLICT: "Tài khoản đang cập nhật. Vui lòng thử lại sau.",
      FOLLOW_EXISTS: "Bạn đã theo trader này",
      FOLLOW_LIMIT: "Bạn đã có quan hệ sao chép đang hoạt động. Hãy kết thúc trước khi theo trader khác.",
      FOLLOW_FAILED: "Bắt đầu sao chép thất bại. Vui lòng thử lại sau.",
      FOLLOW_NOT_FOUND: "Không tìm thấy quan hệ sao chép",
      PAUSE_FAILED: "Tạm dừng sao chép thất bại. Vui lòng thử lại sau.",
      RESUME_FAILED: "Tiếp tục sao chép thất bại. Vui lòng thử lại sau.",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "Kết thúc sao chép thất bại. Vui lòng thử lại sau.",
      APPLICATION_NOT_FOUND: "Không tìm thấy đơn chờ duyệt",
      APPROVE_FAILED: "Duyệt đơn thất bại. Vui lòng thử lại sau.",
      REJECT_FAILED: "Từ chối đơn thất bại. Vui lòng thử lại sau.",
      KICK_FAILED: "Loại người theo thất bại. Vui lòng thử lại sau.",
      SETTLEMENT_WINDOW: "Không thể đổi cài đặt trader trong cửa sổ quyết toán",
      CANCEL_FAILED: "Yêu cầu hủy thất bại. Vui lòng thử lại sau.",
      CANCEL_NOT_PENDING: "Không có yêu cầu hủy để rút",
      CANCEL_WITHDRAW_FAILED: "Rút yêu cầu hủy thất bại. Vui lòng thử lại sau.",
      COPY_SETTINGS_MISSING: "Cài đặt sao chép giao dịch chưa sẵn sàng. Vui lòng thử lại sau.",
      INVALID_SYMBOL: "Chọn ít nhất một mã được hỗ trợ",
      SYMBOL_NOT_ALLOWED: "Có mã trader này không cho phép",
      TRADER_BALANCE_TOO_LOW: "Số dư khả dụng sau đóng băng ký quỹ quá thấp để đăng ký",
      TIMEOUT: "Thao tác thất bại. Vui lòng thử lại sau.",
      NETWORK: "Thao tác thất bại. Vui lòng thử lại sau."
    },
    status: {
      ACTIVE: "Đang hoạt động",
      PAUSED: "Tạm dừng",
      ENDED: "Đã kết thúc",
      PENDING_REVIEW: "Chờ trader duyệt",
      CANCEL_PENDING: "Đang chờ hủy",
      CANCELLED: "Đã hủy"
    },
    traderStatus: {
      ACTIVE: "Đang dẫn",
      CANCEL_PENDING: "Đang thoát",
      CANCELLED: "Đã hủy",
    },
    pauseReason: {
      USER: "Người dùng tạm dừng",
      INSUFFICIENT_BALANCE: "Tạm dừng do số dư tài khoản copy không đủ",
      TAKE_PROFIT: "Chốt lời kích hoạt",
      STOP_LOSS: "Cắt lỗ kích hoạt",
      TRADER_KICK: "Bị trader loại",
      SWITCH: "Đổi trader",
      SETTLEMENT_CLEANUP: "Bị loại khi quyết toán tuần",
      TRADER_CANCEL: "Trader hủy"
    },
    followMode: {
      EQUAL: "Số tiền bằng nhau",
      RATIO: "Tỷ lệ"
    },
    insuranceMode: {
      FOLLOW: "Theo trader",
      ALWAYS_ON: "Luôn bật",
      ALWAYS_OFF: "Luôn tắt"
    },
    reviewMode: {
      AUTO: "Theo tự động",
      MANUAL: "Theo cần duyệt"
    },
    applicationStatus: {
      PENDING: "Chờ duyệt",
      APPROVED: "Đã duyệt",
      REJECTED: "Đã từ chối",
      CANCELLED: "Đã hủy",
      PENDING_REVIEW: "Chờ duyệt"
    }
  },}
